/* eslint sort-keys-fix/sort-keys-fix: ["error", "asc", {natural: false}] */
const strings: { [key in string]: string } = {
  ACCEPT_ALL: 'Aceptar todos',
  ACCESS_DEACTIVATED: 'Acceso al panel desactivado',
  ACCESS_LEVEL_CHANGED: 'Permisos actualizados: puede tardar hasta una hora en aplicarse',
  ACCESS_REACTIVATED: 'Acceso al panel reactivado',
  ACCOUNT: 'Cuenta',
  ACCOUNTING_AND_AUDITING: 'Contabilidad y Auditoría',
  ACCOUNTS: 'Cuentas',
  ACCOUNTS_SUBTITLE: 'Administra tu organización y cuentas de clientes',
  ACCOUNT_ALREADY_EXISTS: 'La cuenta ya existe',
  ACCOUNT_CREATION: 'Creación de cuenta',
  ACCOUNT_DETAILS: 'Detalles de la cuenta',
  ACCOUNT_DETAILS_COPIED: 'Detalles de la cuenta copiados al portapapeles',
  ACCOUNT_HASH: 'N.° de cuenta',
  ACCOUNT_INFORMATION_ERROR:
    'Hubo un error al encontrar tu cuenta virtual, por favor intenta de nuevo más tarde.',
  ACCOUNT_NAME: 'Nombre de cuenta',
  ACCOUNT_NAME_INVALID: 'Solo se permiten letras, números, espacios, guiones y guiones bajos',
  ACCOUNT_NAME_PLACEHOLDER: 'ej., Cuentas por Cobrar',
  ACCOUNT_NAME_REQUIRED: 'El nombre de cuenta es requerido',
  ACCOUNT_NAME_TOO_LONG: 'El nombre de cuenta es demasiado largo',
  ACCOUNT_NOT_FOUND: 'Cuenta no encontrada',
  ACCOUNT_NUMBER: 'Número de cuenta',
  ACCOUNT_NUMBER_COPIED: 'Número de cuenta copiado con éxito',
  ACCOUNT_NUMBER_DETAILS: 'Número de cuenta',
  ACCOUNT_NUMBER_WITH_CURRENCY: 'Número de cuenta ({0})',
  ACCOUNT_SETUP: 'Configuración de cuenta',
  ACCOUNT_TYPE: 'Tipo de cuenta',
  ACCOUNT_TYPE_CHECKING: 'Cuenta corriente',
  ACCOUNT_TYPE_RUT: 'Cuenta RUT',
  ACCOUNT_TYPE_SAVINGS: 'Cuenta de ahorros',
  ACCOUNT_TYPE_VISTA: 'Cuenta vista',
  ACH: 'ACH',
  ACTIONS: 'Acciones',
  ACTION_REQUIRED: 'Acción requerida',
  ACTIVE: 'Activo',
  ACTIVITY: 'Actividad',
  ADD: 'Agregar',
  ADDITIONAL_DOCUMENTATION_REQUESTED:
    'Se ha solicitado documentación adicional para esta transacción.',
  ADDRESS: 'Dirección',
  ADDRESS_COMPLEMENT: 'Complemento de dirección',
  ADD_ACCOUNT: 'Agregar cuenta',
  ADD_APPROVAL_RULE: 'Agregar regla',
  ADD_CONTACT: 'Agregar contacto',
  ADD_CONTACT_FLOW_MODAL_CURRENCY_DESCRIPTION: 'Moneda: {0}',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_ACH: 'ACH, Wire o RTP',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_BI_FAST: 'BI-FAST (IDR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_BOB_ACH: 'Transferencia local (Bolivia)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CCE: 'CCE (PEN)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CHATS: 'CHATS',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CNAPS: 'CNAPS',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_COP: 'ACH Colombia',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CRYPTO: 'Stablecoins',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CVU: 'Transferencia bancaria (CVU o CBU)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_EFT: 'EFT (CAD)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_FAST: 'FAST (TRY)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_FASTER_PAYMENTS: 'Faster Payments (GBP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_GHIPSS: 'GHIPSS (GHS)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_IMPS: 'IMPS (INR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_INSTAPAY: 'InstaPay (PHP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_IPP: 'IPP (AED)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_MOBILE_WALLET: 'Billetera móvil',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_NIP: 'NIP (NGN)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PESALINK: 'PesaLink (KES)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PIX: 'Pix',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PROMPTPAY: 'PromptPay (THB)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_RTC: 'RTC (ZAR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_RTP: 'ACH, Wire o RTP',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SEPA: 'SEPA',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SPEI: 'Spei',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SWIFT: 'Swift',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_TEF: 'TEF (CLP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_WIRE: 'ACH, Wire o RTP',
  ADD_DIGITAL_DOLLARS_LEGACY: 'Agregar dolares digitales',
  ADD_DOCUMENTS: 'Agregar documentos',
  ADD_FUNDS: 'Agregar fondos',
  ADD_FX_MARKUP: 'Agrega tu margen FX',
  ADD_FX_MARKUP_DESCRIPTION:
    'Genera ingresos en las transacciones de tus clientes agregando un margen. Tu spread se incluirá en la cotización anterior.',
  ADD_NEW: 'Agregar nuevo',
  ADD_NEW_CONTACT: 'Agregar nuevo contacto',
  ADD_NEW_CONTACT_WHICH_TYPE: '¿Qué tipo de contacto te gustaría agregar?',
  ADD_NEW_CUSTOMER: 'Agregar cliente',
  ADD_NEW_RECIPIENT: 'Agregar nuevo destinatario',
  ADD_NEW_ROLE: 'Agregar nuevo rol',
  ADD_NEW_USER: 'Agregar nuevo usuario',
  ADD_NEW_WITHDRAWAL_ACCOUNT: 'Agregar nueva cuenta de retiro',
  ADD_NICKNAME: 'Crear alias',
  ADD_PAYMENT_METHOD: 'Agregar método de pago',
  ADD_PAYMENT_METHOD_TO_EXISTING_CONTACT_TITLE:
    '¿Deseas agregar un método de pago a un contacto existente o a uno nuevo?',
  ADD_USDC: 'Agregar USDC',
  ADD_USD_ACCOUNT: 'Agregar cuenta USD',
  ADD_YOUR_BUSINESS_INFORMATION: 'Agregar información de tu negocio',
  ADMIN: 'Administrador',
  ADMINISTRATOR: 'Administrador',
  ADMIN_DESCRIPTION:
    'Gestión de equipo, capacidades de transacción, ver y descargar historial de transacciones y reportes de actividad',
  ALL: 'Todos',
  ALL_TYPES: 'Todos los tipos',
  ALREADY_HAVE_ACCOUNT: '¿Ya tienes una cuenta?',
  AMOUNT: 'Monto',
  AMOUNT_ADDED_TO_WALLET: 'Monto agregado a la cartera',
  AMOUNT_BIGGER_THAN_BALANCE: 'El monto no puede ser mayor que tu saldo (${0})',
  AMOUNT_EXCEEDS_AVAILABLE_EARNINGS:
    'El monto no puede ser mayor que tus ganancias disponibles ({0})',
  AMOUNT_TO_CONVERT: 'Monto a convertir',
  AND_READ_UNDERSTOOD_OUR: 'y que has leído y entendido nuestra',
  ANNOUNCEMENT_ACKNOWLEDGE_AND_CLOSE: 'Confirmar y cerrar',
  ANNOUNCEMENT_ACKNOWLEDGE_ERROR: 'Algo salió mal. Inténtalo de nuevo.',
  ANNOUNCEMENT_BACK: 'Atrás',
  ANNOUNCEMENT_CLOSE: 'Cerrar anuncio',
  ANNOUNCEMENT_FEATURE: 'Anuncio de funcionalidad',
  ANNOUNCEMENT_GOT_IT: 'Entendido',
  ANNOUNCEMENT_NEXT: 'Siguiente',
  ANNOUNCEMENT_NEXT_STEP: 'Siguiente paso',
  ANNOUNCEMENT_PREVIOUS_STEP: 'Paso anterior',
  ANY: 'Cualquiera',
  AN_ERROR_OCCURRED: 'Ocurrió un error desconocido, por favor intenta de nuevo más tarde.',
  API_CREDENTIALS: 'Credenciales API',
  API_CREDENTIALS_KEYS_SECTION_DESCRIPTION:
    'Úsalos para autenticar tu integración con la API de Caliza. Trata los valores secretos como contraseñas.',
  API_CREDENTIALS_KEYS_SECTION_LABEL: 'Llaves y secretos',
  API_CREDENTIALS_UPDATE_ERROR: 'No se pudieron actualizar las credenciales API',
  API_CREDENTIALS_UPDATE_SUCCESS: 'Credenciales API actualizadas',
  API_CREDENTIALS_WEBHOOK_SECTION_DESCRIPTION:
    'A dónde enviamos los eventos de webhook y a quién notificamos sobre la actividad del integrador.',
  API_CREDENTIALS_WEBHOOK_SECTION_LABEL: 'Configuración de webhook',
  API_ERROR_CORRIDOR_NOT_AVAILABLE:
    'Esta ruta de transferencia aún no está disponible para la moneda y el destino seleccionados. Contacta a soporte para habilitarla.',
  API_ERROR_INSUFFICIENT_BALANCE:
    'Saldo insuficiente. Intenta con un monto menor o fondea la cuenta primero.',
  API_ERROR_PAYMENT_APPROVAL_NO_ELIGIBLE_APPROVER:
    'Este pago requiere aprobación, pero tu organización no tiene un aprobador elegible además de ti. Un administrador debe otorgar el permiso de aprobación a otro miembro del equipo.',
  API_ERROR_RECIPIENT_CRYPTO_NOT_APPROVED:
    'Este destinatario de cripto aún no ha sido aprobado. Contacta a soporte para habilitarlo.',
  API_ERROR_RECIPIENT_NOT_FOUND:
    'Destinatario no encontrado. Selecciona un destinatario diferente.',
  API_ERROR_RECIPIENT_UNDER_REVIEW:
    'Este destinatario está en revisión y aún no puede usarse para transferencias. Contacta a soporte.',
  API_ERROR_RECIPIENT_VALIDATION:
    'No pudimos validar los datos del destinatario. Revísalos e intenta de nuevo.',
  API_ERROR_SIMULATION_MAXIMUM_AMOUNT:
    'El monto está por encima del máximo permitido para esta ruta.',
  API_ERROR_SIMULATION_MAXIMUM_AMOUNT_VALUE:
    'El monto está por encima del máximo permitido para esta ruta ({0}).',
  API_ERROR_SIMULATION_MINIMUM_AMOUNT:
    'El monto está por debajo del mínimo permitido para esta ruta.',
  API_ERROR_SIMULATION_MINIMUM_AMOUNT_VALUE:
    'El monto está por debajo del mínimo permitido para esta ruta ({0}).',
  API_ERROR_TRANSACTION_MINIMUM_AMOUNT: 'El monto mínimo para esta transacción es {0}.',
  API_ERROR_TRANSACTION_MINIMUM_NOT_CONFIGURED:
    'No hay un monto mínimo configurado para esta ruta. Contacta a soporte.',
  API_ERROR_TRAVEL_RULE_OWNERSHIP_PROOF_REQUIRED:
    'Esta billetera auto-alojada requiere una comprobación de titularidad verificada antes de simular o enviar esta operación. Verifica primero la titularidad de la billetera del destinatario seleccionado.',
  API_ERROR_TRAVEL_RULE_PROOF_INVALID:
    'No se pudo verificar la firma para esta dirección de billetera. Firma con la billetera titular de la dirección registrada.',
  API_USER: 'Usuario de API',
  API_USER_HELPER:
    'Los usuarios de API acceden a la plataforma de forma programática y omiten la configuración de la autenticación de dos factores.',
  APPEARANCE: 'Apariencia',
  APPLY: 'Aplicar',
  APPROVAL_ADMIN_INITIATED_DESCRIPTION:
    'Cuando está desactivado, las transferencias y los retiros iniciados por un administrador omiten la aprobación. Cuando está activado, los administradores quedan sujetos a las mismas reglas que los demás.',
  APPROVAL_ADMIN_INITIATED_DISABLED_HINT:
    'Esto se aplica cuando hay al menos una regla de aprobación activada.',
  APPROVAL_ADMIN_INITIATED_LABEL:
    'Exigir aprobación también para las transacciones iniciadas por administradores',
  APPROVAL_ADMIN_INITIATED_TOGGLE_ERROR:
    'No se pudo actualizar la configuración. Inténtalo de nuevo.',
  APPROVAL_NOTE_OPTIONAL: 'Nota (opcional)',
  APPROVAL_RULE: 'Regla de aprobación',
  APPROVAL_RULE_CURRENCY_ALREADY_USED: 'Ya existe una regla para esta moneda de billetera',
  APPROVAL_RULE_DELETE_ERROR: 'No se pudo eliminar la regla. Inténtalo de nuevo.',
  APPROVAL_RULE_DELETE_SUCCESS: 'Regla eliminada',
  APPROVAL_RULE_DISABLED: 'Deshabilitada',
  APPROVAL_RULE_ENABLED: 'Habilitada',
  APPROVAL_RULE_SAVE_ERROR: 'No se pudo guardar la regla. Inténtalo de nuevo.',
  APPROVAL_RULE_SAVE_SUCCESS: 'Regla guardada',
  APPROVAL_RULE_TOGGLE_ERROR: 'No se pudo actualizar la regla. Inténtalo de nuevo.',
  APPROVAL_RULE_VALUE_INVALID: 'El monto no puede ser negativo.',
  APPROVAL_RULE_ZERO_THRESHOLD_HINT:
    'Si {0} todas las transferencias y retiros de la billetera Caliza seleccionada se retendrán para aprobación.',
  APPROVE: 'Aprobar',
  APPROVED: 'Aprobado',
  APPROVED_DESC: 'Tu transacción fue aprobada.',
  APP_ERROR_BOUNDARY_DESCRIPTION:
    'Ocurrió un error inesperado. Por favor actualiza la página e intenta de nuevo.',
  APP_ERROR_BOUNDARY_REFRESH: 'Actualizar página',
  APP_ERROR_BOUNDARY_TITLE: 'Algo salió mal',
  APP_ERROR_BOUNDARY_TRY_AGAIN: 'Reintentar',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_DESCRIPTION: 'Esta acción no es reversible.',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_TITLE:
    '¿Estás seguro de que quieres eliminar esta cuenta?',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTACT_DESCRIPTION: 'Esta acción no es reversible.',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTACT_TITLE:
    '¿Estás seguro de que quieres eliminar este contacto?',
  ARE_YOU_SURE_YOU_WANT_TO_LEAVE_WITHOUT_HASH:
    '¿Estás seguro de que quieres salir sin proporcionar un hash de transacción?',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THESE_USERS_FROM_YOUR_TEAM: `Tem certeza que deseja remover {0} da sua equipe?`,
  ASSET_TYPE: 'Tipo de activo',
  AVAILABLE_BALANCE: 'Ganancias disponibles para reclamar',
  AVAILABLE_BALANCE_TOOLTIP:
    'Este es tu saldo de ganancias por margen. Es independiente de tu saldo de tesorería en USDC.',
  AVAILABLE_BY_DEFAULT: 'Disponible por defecto',
  AWAITING_APPROVAL: 'Pendiente de aprobación',
  AWAITING_APPROVAL_DESC: 'Tu transacción está pendiente de aprobación.',
  AWAITING_FUNDING_ALERT:
    'Esta transacción tiene una tasa de cambio garantizada y está pendiente de fondear.',
  AWAITING_FUNDING_ALERT_TRANSACTIONS_LIST_ACTION:
    'Ver los detalles de la transacción para completar.',
  AWAITING_FUNDING_ALERT_TRANSACTION_DETAILS_DRAWER_ACTION:
    'Fondea esta transacción antes de que venza.',
  AWAITING_FUNDING_BANNER_PLURAL: 'Tienes {0} transacciones pendientes de fondear.',
  AWAITING_FUNDING_BANNER_SINGULAR: 'Tienes 1 transacción pendiente de fondear.',
  AWAITING_FUNDING_FILTER_LABEL: 'Mostrar solo transacciones pendientes de fondear',
  BACK: 'Atrás',
  BACK_TO_APPLICATION: 'Volver a la aplicación',
  BACK_TO_CUSTOMER: 'Volver al cliente',
  BACK_TO_DASHBOARD: 'Volver al panel',
  BACK_TO_LOGIN: 'Volver a iniciar sesión',
  BALANCE: 'Saldo',
  BANK: 'Banco',
  BANK_ACCOUNT: 'Cuenta bancaria',
  BANK_ACCOUNT_INFORMATION: 'Información de la cuenta bancaria',
  BANK_ACCOUNT_NUMBER: 'Número de cuenta bancaria',
  BANK_ACCOUNT_TYPE: 'Tipo de cuenta bancaria',
  BANK_ADDRESS: 'Dirección del banco',
  BANK_CODE: 'Código de banco',
  BANK_CODE_CNAPS: 'Código Bancario (CNAPS)',
  BANK_CODE_CNAPS_NOT_FOUND:
    'Banco no encontrado: escribe el código CNAPS de 12 dígitos si no encuentras tu banco',
  BANK_INFORMATION: 'Información bancaria',
  BANK_NAME: 'Nombre del banco',
  BANK_NETWORK: 'Banco / red',
  BENEFICIARIES: 'Beneficiarios',
  BENEFICIARY_ADDRESS: 'Dirección del beneficiario',
  BENEFICIARY_NAME: 'Nombre del beneficiario',
  BENEFICIARY_ONBOARDING_INVITED_BY: '{0} de {1} te invitó a Caliza',
  BENEFICIARY_ONBOARDING_PARTNERED_WITH_CALIZA:
    '{0} se asoció con Caliza para gestionar pagos internacionales. Crea una contraseña para ver tus operaciones, dar seguimiento a fondos y pagos, y descargar reportes de transacciones.',
  BENEFICIARY_ONBOARDING_PARTNERED_WITH_CALIZA_FOR:
    '{0} se asoció con Caliza para gestionar pagos internacionales. Crea una contraseña para dar seguimiento a fondos, ver pagos y descargar reportes de transacciones de',
  BENEFICIARY_OR_RECIPIENT_CONTACT: 'Contacto del beneficiario o destinatario',
  BENEFICIARY_ROLE: 'Beneficiario',
  BENEFIT_CROSS_BORDER_SUPPLY_CHAIN: 'Cadena de suministro transfronteriza',
  BENEFIT_CROSS_BORDER_SUPPLY_CHAIN_DESCRIPTION:
    'Simplifica las cuentas por pagar y por cobrar internacionales',
  BENEFIT_GLOBAL_MERCHANT_SETTLEMENT: 'Liquidación global para comercios',
  BENEFIT_GLOBAL_MERCHANT_SETTLEMENT_DESCRIPTION:
    'Pagos instantáneos para marketplaces, e-commerce y plataformas',
  BENEFIT_INTERNATIONAL_PAYROLL: 'Nómina internacional',
  BENEFIT_INTERNATIONAL_PAYROLL_DESCRIPTION: 'Paga a tu equipo internacional en USDC',
  BENEFIT_TREASURY_MANAGEMENT: 'Gestión de tesorería',
  BENEFIT_TREASURY_MANAGEMENT_DESCRIPTION:
    'Optimiza las operaciones de tesorería internacional y los saldos de caja',
  BRAZILIAN_PIX: 'Real brasileño (Pix)',
  BRL1_WALLET: 'Billetera BRL1',
  BRL_MARKET_HOURS_ALERT:
    'Las operaciones en BRL solo se pueden completar durante el horario comercial: de lunes a viernes, de 9:00 a 15:40 BRT (excepto días festivos).',
  BUSINESS: 'Empresa',
  BUSINESS_EMAIL: 'Correo electrónico de negocios',
  BUSINESS_INFORMATION: 'Información de la empresa',
  BUSINESS_NAME: 'Nombre de la empresa',
  BUSINESS_RELATIONSHIP: 'Relación comercial',
  BY_CONFIRMING_EMAIL_AGREE: 'Al confirmar tu email, aceptas nuestros',
  CALIZA_ACCOUNT: 'Cuenta Caliza ({0})',
  CALIZA_BENEFITS: 'Beneficios de Caliza',
  CALIZA_DOES_NOT_CHARGE_DEPOSIT_FEES:
    'Caliza no cobra ninguna comisión por depósito. Sin embargo, tu cartera externa puede cobrar comisiones por transferir fondos.',
  CALIZA_RATE: 'Cotización Caliza',
  CALIZA_RATE_TOOLTIP: 'La cotización Caliza incluye {0} de spread de divisas',
  CALIZA_TERMS_AND_SERVICES: 'Términos y Servicios de Caliza',
  CALIZA_WALLET: 'Cartera Caliza',
  CALIZA_WALLET_BALANCE: 'Saldo de cartera Caliza',
  CALIZA_WALLET_FEE_NOTE: 'Se pueden aplicar comisiones',
  CALLBACK_URL: 'URL de callback',
  CANCEL: 'Cancelar',
  CANCEL_TRANSFER: 'Cancelar transferencia',
  CANT_SCAN_THE_CODE: '¿No puedes escanear el código?',
  CHAIN: 'Cadena',
  CHAIN_ETHEREUM: 'Ethereum',
  CHAIN_POLYGON: 'Polygon',
  CHAIN_TRON: 'TRON',
  CHAIN_UNKNOWN: 'Desconocido',
  CHANGE_PASSWORD_DESCRIPTION: 'Confirmación cuando se cambie tu contraseña',
  CHANGE_PASSWORD_LABEL: 'Cambiar contraseña',
  CHECKING: 'Cuenta corriente',
  CHECK_EMAIL_FOR_CODE: 'Por favor, consulta {0} para obtener tu código de un solo uso',
  CHECK_HISTORY_DESCRIPTION:
    'Revisa tu historial para seguir el estado de la transferencia. Los detalles de la transacción pueden tardar unos minutos antes de aparecer.',
  CHECK_YOUR_PAYMENT_HISTORY_TO_TRACK_STATUS:
    'Revisa tu historial de pagos para rastrear el estado del pago.',
  CHOOSE_DEPOSIT_AMOUNT: 'Elige el monto del depósito',
  CITY: 'Ciudad',
  CLABE_INVALID: 'La CLABE debe tener exactamente 18 dígitos',
  CLAIM: 'Reclamar',
  CLAIM_EARNINGS: 'Reclamar ganancias',
  CLEAR: 'Limpiar',
  CLICK_HERE: 'haz clic aquí',
  CLIENT_ID: 'Client ID',
  CLIENT_SECRET: 'Client secret',
  CLOSE: 'Cerrar',
  CODE_EXPIRED: 'El código ha expirado. Por favor, solicita uno nuevo',
  CODE_RESENT: 'Código reenviado',
  COMING_SOON: 'Pronto disponible',
  COMMA_AND_ONE: ', y un',
  COMMA_ONE: ', un',
  COMPANY: 'Empresa',
  COMPLETED: 'Completado',
  COMPLETED_DESCRIPTION:
    'Recibe notificaciones cuando una transferencia esté completa y el destinatario haya recibido sus fondos',
  COMPLETED_LABEL: 'Completo',
  COMPLETED_STATUS: 'Completado',
  CONFIRM: 'Confirmar',
  CONFIRM_DEPOSIT: 'Confirmar Depósito',
  CONFIRM_EARNINGS_CLAIM: 'Confirmar reclamo de ganancias',
  CONFIRM_INTERNAL_TRANSFER: 'Confirmar transferencia interna',
  CONFIRM_NEW_PASSWORD: 'Confirmar nueva contraseña',
  CONFIRM_PASSWORD: 'Confirmar contraseña',
  CONFIRM_PAYMENT: 'Confirmar pago',
  CONFIRM_WITHDRAWAL: 'Confirmar retiro',
  CONTACT: 'Contacto',
  CONTACTS: 'Contactos',
  CONTACT_DETAILS: 'Detalles del contacto',
  CONTACT_EMAILS: 'Correos de contacto',
  CONTACT_EMAILS_HELPER: 'Lista de correos electrónicos separados por coma',
  CONTACT_NICKNAME: 'Apodo del contacto',
  CONTACT_TYPE: 'Tipo de contacto',
  CONTINUE: 'Continuar',
  CONTINUE_WITH_GOOGLE: 'Continuar con Google',
  CONVERSION_QUOTE: 'Cotización de conversión',
  CONVERSION_RATES: 'Cotizaciones de conversión',
  CONVERT: 'Convertir',
  CONVERTED_CURRENCY: 'Moneda convertida',
  CONVERT_ACCOUNT_BALANCE: 'Convertir saldo de la cuenta',
  CONVERT_SUCCESS: 'Conversión completada con éxito',
  COPIED: 'Copiado al portapapeles',
  COPIED_TO_CLIPBOARD: 'Copiado al portapapeles',
  COPY: 'Copiar',
  COPY_ALL: 'Copiar todo',
  COPY_CLABE: 'Copiar CLABE',
  COPY_LINK: 'Copiar enlace',
  COUNTRY: 'País',
  COUNTRY_NOT_SUPPORTED_PREFIX: 'No podemos enviar pagos a ',
  COUNTRY_NOT_SUPPORTED_SUFFIX: '.',
  COUNTRY_NOT_SUPPORTED_YET: 'Aún no podemos enviar pagos a {0}.',
  COUNTRY_OF_RESIDENCE: 'País de residencia',
  COUNTRY_RESTRICTED_PREFIX: 'Los pagos a ',
  COUNTRY_RESTRICTED_SUFFIX: ' están restringidos.',
  COUNT_OF_COUNT_COMPLETE: '{0} de {1} completo',
  CO_CC_LABEL: 'Cédula de Ciudadanía',
  CO_CE_LABEL: 'Cédula de Extranjería',
  CO_NIT_LABEL: 'Número de Identificación Tributaria',
  CO_SPECIAL_RESIDENCE_PERMIT: 'Permiso Especial de Permanencia',
  CREATE: 'Crear',
  CREATED: 'Creado',
  CREATED_DESC: 'Su transacción fue creada.',
  CREATED_WAITING_FUNDING_DESC: 'Su transacción fue creada y está esperando ser financiada.',
  CREATE_A_CALIZA_ACCOUNT: 'Crear una\ncuenta Caliza',
  CREATE_CUSTOM_ROLE_NAME: 'Crear un nombre para este rol personalizado:',
  CREATE_INTEGRATOR_SUCCESS: 'Integrator created successfully',
  CREATE_TRANSACTIONS: 'Crear transacciones',
  CREATE_USD_ACCOUNT: 'Crear cuenta USD',
  CREATE_USD_ACCOUNT_DESCRIPTION:
    'Habilita una cuenta en USD para este cliente y desbloquea potentes funciones bancarias.',
  CREATE_USD_ACCOUNT_DISABLED_TOOLTIP:
    'La creación de cuentas USD no está habilitada, por favor contacte al equipo de Caliza para habilitarla.',
  CREATE_USER_FAILED: 'Se produjo un error al crear el usuario',
  CREATE_USER_SUCCESS: 'Usuario creado exitosamente',
  CREATING: 'Creando',
  CROSS_BORDER_SUPPLY_CHAIN: 'Cadena de Suministro Transfronteriza',
  CROSS_BORDER_SUPPLY_CHAIN_DESC: 'Simplifica las cuentas por pagar y por cobrar internacionales',
  CRYPTO_ACCOUNT_INFORMATION: 'Información de la cuenta stablecoin',
  CRYPTO_DEPOSIT_COMPLETED_DESCRIPTION:
    'Check your activity to track the status of the transfer. Transaction details can take a few minutes before they appear. ',
  CRYPTO_DEPOSIT_COMPLETED_TITLE: 'Once we receive your funds, we will complete your deposit',
  CRYPTO_HASH_TRANSFER_MODAL_DESCRIPTION:
    'The transaction hash to automatically reconcile your incoming deposit.',
  CRYPTO_HASH_TRANSFER_MODAL_TITLE: 'Share the transaction hash provided by your external wallet',
  CRYPTO_INTERNAL_TRANSFER: 'Transferencia interna',
  CRYPTO_NETWORK: 'Red',
  CRYPTO_NON_CUSTODIAL_WALLET: 'Billetera no custodial (auto-alojada)',
  CRYPTO_THIRD_PARTY_ADDRESS_INFO:
    'Las regulaciones exigen la dirección del titular de la billetera para transferencias a billeteras auto-alojadas de terceros.',
  CRYPTO_TRANSFER_COMPLETED_DESCRIPTION:
    'Check your activity to track the status of the transfer. Transaction details can take a few minutes before they appear. ',
  CRYPTO_TRANSFER_COMPLETED_TITLE: 'Once we receive your funds, we will complete your transfer',
  CRYPTO_TRANSFER_MODAL_DESCRIPTION:
    'Copia el hash de la transacción de tu billetera o exchange y pégalo aquí para que podamos verificar tu depósito. Una vez confirmado, tu transferencia se completará y aparecerá en tu historial de transacciones.',
  CRYPTO_TRANSFER_MODAL_SEND_FUNDS_DESCRIPTION:
    'Envía fondos a la dirección de billetera a continuación. Una vez que recibamos tu transferencia, se completará y aparecerá en tu historial de transacciones.',
  CRYPTO_TRANSFER_MODAL_SEND_FUNDS_TITLE: 'Envía fondos a esta dirección de billetera',
  CRYPTO_TRANSFER_MODAL_TITLE: 'Comparte el hash de la transacción para completar tu operación',
  CRYPTO_VASP: 'Proveedor de Servicios de Activos Virtuales (VASP)',
  CRYPTO_VASP_NAME: 'Nombre del VASP',
  CRYPTO_VASP_OTHER: 'Otro (escribir nombre del VASP)',
  CRYPTO_WALLET_ADDRESS: 'Dirección de la billetera',
  CURRENCY_CONVERT_TO_STABLECOIN:
    '{0} se convertirá automáticamente a una stablecoin una vez que recibamos tu depósito.',
  CURRENCY_TYPE: 'Tipo de moneda',
  CURRENCY_TYPE_LABEL: 'Tipo de moneda',
  CURRENT_PASSWORD: 'Contraseña actual',
  CUSTOM: 'Personalizado',
  CUSTOMER: 'Cliente',
  CUSTOMERS: 'Clientes',
  CUSTOMERS_SUBTITLE: 'Administra el onboarding de clientes',
  CUSTOMER_ACCOUNTS: 'Cuentas de clientes',
  CUSTOMER_ACCOUNT_BALANCES: 'Saldos del cliente',
  CUSTOMER_BALANCE: 'Saldo del Cliente',
  CUSTOMER_GETS: 'El cliente recibe',
  CUSTOMER_RATE_TOOLTIP: 'La cotización del cliente incluye tu margen FX de {0}',
  CUSTOMER_SUCCESS: 'Éxito del Cliente',
  CUSTOMER_TYPE: 'Tipo de cliente',
  CUSTOMER_VERIFICATION_CREATE_ERROR: 'Error al crear la verificación del cliente',
  CUSTOMER_VERIFICATION_ERROR: 'Ocurrió un error durante la verificación',
  CUSTOMER_VERIFICATION_INFO:
    'Por favor complete la configuración para verificación y continuar con las transferencias',
  CUSTOMER_VERIFICATION_STARTED_SUCCESS: 'Verificación del cliente iniciada con éxito',
  CUSTOMER_VERIFICATION_STATUS_INFO:
    'Por favor complete la configuración para verificación y continuar con las transferencias',
  CUSTOMER_VERIFICATION_SUCCESS: 'Verificación completada con éxito',
  CVU: 'CVU',
  CVU_OR_CBU: 'CVU o CBU',
  DARK: 'Oscuro',
  DASHBOARD_ACCESS: 'Acceso al panel',
  DASHBOARD_ACCESS_ALREADY_GRANTED: 'Este cliente ya tiene acceso al panel',
  DASHBOARD_ACCESS_DESCRIPTION:
    'Dale a este cliente un acceso para administrar su propia cuenta: saldos, actividad, destinatarios y pagos.',
  DASHBOARD_ACCESS_LOAD_ERROR: 'No pudimos cargar el acceso al panel de este cliente',
  DASHBOARD_ACCESS_NONE_YET: 'Este cliente todavía no tiene acceso al panel.',
  DASHBOARD_ACCESS_NONE_YET_HINT:
    'Recibirá una invitación por correo electrónico para crear su contraseña.',
  DASHBOARD_ACCESS_REQUIRES_APPROVAL:
    'Disponible cuando se apruebe la verificación de este cliente.',
  DATE: 'Fecha',
  DATE_AND_TIME: 'Fecha y hora',
  DAY: 'Día',
  DEACTIVATE: 'Desactivar',
  DEACTIVATED: 'Desactivado',
  DEACTIVATED_ON: 'Desactivado el {0}',
  DEACTIVATE_ACCESS_DESCRIPTION:
    '{0} perderá el acceso al panel de inmediato. Puedes reactivar este acceso en cualquier momento.',
  DEACTIVATE_ACCESS_TITLE: '¿Desactivar el acceso al panel?',
  DEACTIVATE_ACCOUNT: 'Desactivar cuenta',
  DEACTIVATE_USER: 'Desactivar usuario',
  DECLINED: 'Rechazado',
  DEFAULT: 'Por defecto',
  DELETE: 'Eliminar',
  DELETE_ACCOUNT: 'Eliminar cuenta',
  DELETE_APPROVAL_RULE: 'Eliminar regla',
  DELETE_APPROVAL_RULE_CONFIRM_DESCRIPTION:
    'Las transacciones ya no se retendrán para aprobación por esta regla.',
  DELETE_APPROVAL_RULE_CONFIRM_TITLE: '¿Eliminar esta regla de aprobación?',
  DELETE_CONTACT: 'Eliminar contacto',
  DELETE_CONTACT_SUCCESS: 'Contacto eliminado con éxito',
  DELETE_PAYMENT_METHOD_SUCCESS: 'Método de pago eliminado con éxito',
  DEPARTMENT: 'Departamento',
  DEPOSIT: 'Depósito',
  DEPOSITING_FOR: 'Depositando para',
  DEPOSITO_DE: 'Depósito de {0}',
  DEPOSIT_ACTION: 'Depositar',
  DEPOSIT_COMPLETED: 'Depósito Completado',
  DEPOSIT_COMPLETED_DESC: 'Su depósito ha sido completado.',
  DEPOSIT_COMPLETED_DESCRIPTION: 'Recibe notificaciones cuando un depósito haya sido completado',
  DEPOSIT_COMPLETED_LABEL: 'Completado',
  DEPOSIT_COMPLETED_TITLE: 'Tus fondos han sido agregados',
  DEPOSIT_CREATED_DESCRIPTION: 'Recibe notificaciones cuando un depósito haya sido creado',
  DEPOSIT_CREATED_LABEL: 'Creado',
  DEPOSIT_CREDENTIALS_DESCRIPTION:
    'Transfiere USD desde tu banco usando los detalles de depósito proporcionados.\n\nAcreditaremos tu cuenta automáticamente cuando lleguen los fondos.',
  DEPOSIT_CREDENTIALS_TITLE: 'Envía fondos desde tu banco',
  DEPOSIT_DETAILS: 'Detalles del depósito',
  DEPOSIT_FAILED_DESCRIPTION: 'Recibe notificaciones cuando un depósito haya fallado',
  DEPOSIT_FAILED_LABEL: 'Fallido',
  DEPOSIT_FIAT_ACCOUNT_MODAL_DESCRIPTION:
    'Una vez que recibamos tus fondos de tu banco, automáticamente enviaremos tu transferencia y confirmaremos por correo electrónico y en tu historial de transacciones.',
  DEPOSIT_FROM: 'Depósito de {0}',
  DEPOSIT_PENDING_DESCRIPTION:
    'Recibimos tu {0} y estamos procesando tu depósito. Los depósitos pueden tardar hasta 4 minutos en completarse. Puedes seguir el estado de tu depósito en Actividad.',
  DEPOSIT_PENDING_TITLE: 'Estamos depositando tus fondos',
  DEPOSIT_RECEIVED: 'Depósito Recibido',
  DEPOSIT_RECEIVED_DESC: 'Su depósito ha sido recibido.',
  DEPOSIT_STATUS: 'Estado del depósito',
  DEPOSIT_TRANSACTION_HASH: 'Hash de transacción de depósito',
  DESCRIPTION_OF_ROLE_OPTIONAL: 'Descripción del Rol (Opcional)',
  DESELECT_ALL: 'Deseleccionar todo',
  DESTINATION_COUNTRY: 'País de la cuenta del destinatario',
  DESTINATION_TYPE: 'Tipo de destino',
  DETAILS: 'Detalles',
  DEVICE_NAME: 'Nombre del dispositivo',
  DEVICE_NAME_HELP: 'Opcional: Dale un nombre a este dispositivo para identificarlo fácilmente',
  DEVICE_NAME_PLACEHOLDER: 'Mi Teléfono',
  DISABLE: 'Inhabilitar',
  DISABLE_TWO_FACTOR_AUTHENTICATION_TITLE:
    '¿Estás seguro de que quieres desactivar la autenticación de dos factores?',
  DISABLING: 'Deshabilitando...',
  DOCUMENT_NUMBER_CPF_CNPJ: 'Número de documento (CPF/CNPJ)',
  DOCUMENT_NUMBER_INVALID:
    'El número de documento debe ser un CPF (11 dígitos) o CNPJ (14 dígitos) válido',
  DOCUMENT_WITH_NAME_TEMPLATE: 'Documento {0}',
  DONE: 'Hecho',
  DONT_HAVE_ACCOUNT: '¿No tienes una cuenta?',
  DONT_SUPPORT_COUNTRY: "We don't support your country yet",
  DOWNLOAD: 'Descargar',
  DOWNLOAD_COMPROVANTE_OPERACAO_TRANSACTION_DOCUMENT:
    'Comprovante de operação de pagamento internacional',
  DOWNLOAD_DETAILED_PAYMENT_CONFIRMATION_TRANSACTION_DOCUMENT:
    'Confirmación detallada de transacción',
  DOWNLOAD_PAYMENT_CONFIRMATION_TRANSACTION_DOCUMENT: 'Confirmación de transacción',
  DOWNLOAD_PDF: 'Descargar PDF',
  DOWNLOAD_TRANSACTION_DOCUMENTS: 'Descargar comprobantes de transacción',
  EARNED: 'Ganado',
  EARNINGS: 'Ganancias',
  EARNINGS_AVAILABLE: 'Ganancias disponibles: {0} {1}',
  EARNINGS_CLAIM_NO_FEES:
    'Reclamar tus ganancias no tiene comisiones. El monto total será transferido al destino seleccionado.',
  EARNINGS_CLAIM_SUCCESS: 'Tu reclamo de ganancias ha sido enviado',
  EARNINGS_DASHBOARD: 'Panel de Ganancias',
  EARNINGS_DETAILS: 'Detalles de ganancias',
  EDIT: 'Editar',
  EDIT_APPROVAL_RULE: 'Editar regla',
  EDIT_NICKNAME: 'Editar apodo',
  EDIT_RECIPIENT_TABS: 'Editar pestañas de destinatario',
  EMAIL: 'E-mail',
  EMAIL_INVALID_FORMAT: 'El formato del correo electrónico no es válido',
  EMAIL_NOT_AVAILABLE: 'Este correo electrónico no se puede usar',
  ENABLE: 'Habilitar',
  ENABLING: 'Habilitando...',
  ENTER_TOTP_CODE: 'Ingresar código',
  ENTER_VERIFICATION_CODE: 'Ingresa el código de verificación',
  ENTER_VERIFICATION_CODE_DESCRIPTION:
    'Ingresa el código de 6 dígitos de tu aplicación autenticadora para completar la configuración',
  ERROR_DISPLAYING_ROW_DATA: 'Error al mostrar datos de la fila',
  ERROR_LOADING_CUSTOMER: 'Error al cargar los detalles del cliente',
  ERROR_LOADING_EARNINGS: 'Error al cargar los datos de ganancias',
  ERROR_LOADING_PREFERENCES: 'Error al cargar preferencias',
  EXCHANGE: 'Cambio',
  EXCHANGE_COMPLETED: 'Cambio completado',
  EXCHANGE_COMPLETED_DESC: 'Su cambio ha sido completado.',
  EXCHANGE_RATE_LOCK: 'Bloqueo de tipo de cambio',
  EXISTING_CONTACT: 'Contacto existente',
  EXPIRED: 'Expirado',
  EXPIRED_DESC: 'Esta transacción ha expirado',
  EXTERNAL_ACCOUNT: 'Externo',
  EXTERNAL_ACCOUNT_ACH: 'Externo',
  EXTERNAL_ACCOUNT_COP: 'Externo',
  EXTERNAL_ACCOUNT_CVU: 'Externo',
  EXTERNAL_ACCOUNT_DESTINATION: 'Cuenta externa',
  EXTERNAL_ACCOUNT_ETH: 'Externo',
  EXTERNAL_ACCOUNT_NO_FEE_NOTE: 'Sin comisiones adicionales',
  EXTERNAL_ACCOUNT_PIX: 'Externo',
  EXTERNAL_ACCOUNT_POLYGON: 'Externo',
  EXTERNAL_ACCOUNT_SPEI: 'Externo',
  EXTERNAL_ACCOUNT_SWIFT: 'Externo',
  EXTERNAL_ACCOUNT_TRON: 'Externo',
  EXTERNAL_ACCOUNT_WIRE: 'Externo',
  EXTERNAL_PAYMENT_REFERENCE_OPTIONAL: 'Referencia de pago externo (Opcional)',
  EXTERNAL_RECIPIENT: 'Destinatario externo',
  FAILED: 'Fallido',
  FAILED_DESC: 'Su pago ha fallado',
  FAILED_DESCRIPTION: 'Recibe notificaciones cuando una transferencia haya fallado',
  FAILED_LABEL: 'Fallido',
  FAILED_TO_LOAD_STATES: 'Error al cargar los estados del país seleccionado.',
  FAILED_TO_LOAD_TRANSACTION_STATUS: 'Error al cargar el estado de la transacción',
  FEATURE_NOT_AVAILABLE_DESCRIPTION:
    'Pedimos disculpas por el inconveniente. Esta función existe pero está temporalmente deshabilitada. Por favor, vuelve más tarde para ver las actualizaciones.',
  FEATURE_NOT_AVAILABLE_TITLE: 'Función actualmente no disponible',
  FEE: 'Tarifa',
  FEES: 'Comisiones',
  FIAT_ACCOUNT_ACH: 'Cuenta Bancaria (ACH)',
  FIAT_ACCOUNT_BI_FAST: 'Cuenta Bancaria (BI-FAST)',
  FIAT_ACCOUNT_BOB_ACH: 'Cuenta Bancaria (Bolivia)',
  FIAT_ACCOUNT_CCE: 'Cuenta Bancaria (CCE)',
  FIAT_ACCOUNT_CHATS: 'Cuenta Bancaria (CHATS)',
  FIAT_ACCOUNT_CNAPS: 'Cuenta Bancaria (CNAPS)',
  FIAT_ACCOUNT_COP: 'COP',
  FIAT_ACCOUNT_CRYPTO: 'Billetera Stablecoin',
  FIAT_ACCOUNT_CVU: 'Transferencia bancaria (CVU o CBU)',
  FIAT_ACCOUNT_EFT: 'Cuenta Bancaria (EFT)',
  FIAT_ACCOUNT_FAST: 'Cuenta Bancaria (FAST)',
  FIAT_ACCOUNT_FASTER_PAYMENTS: 'Cuenta Bancaria (Faster Payments)',
  FIAT_ACCOUNT_GHIPSS: 'Cuenta Bancaria (GHIPSS)',
  FIAT_ACCOUNT_IMPS: 'Cuenta Bancaria (IMPS)',
  FIAT_ACCOUNT_INSTAPAY: 'Cuenta Bancaria (InstaPay)',
  FIAT_ACCOUNT_IPP: 'Cuenta Bancaria (IPP)',
  FIAT_ACCOUNT_MOBILE_WALLET: 'Billetera móvil',
  FIAT_ACCOUNT_NIP: 'Cuenta Bancaria (NIP)',
  FIAT_ACCOUNT_PESALINK: 'Cuenta Bancaria (PesaLink)',
  FIAT_ACCOUNT_PIX: 'Pix',
  FIAT_ACCOUNT_PROMPTPAY: 'Cuenta Bancaria (PromptPay)',
  FIAT_ACCOUNT_RTC: 'Cuenta Bancaria (RTC)',
  FIAT_ACCOUNT_RTP: 'Cuenta Bancaria (RTP)',
  FIAT_ACCOUNT_SEPA: 'Cuenta Bancaria (SEPA)',
  FIAT_ACCOUNT_SPEI: 'SPEI',
  FIAT_ACCOUNT_SWIFT: 'Cuenta Bancaria (SWIFT)',
  FIAT_ACCOUNT_TEF: 'Cuenta Bancaria (TEF)',
  FIAT_ACCOUNT_WIRE: 'Cuenta Bancaria (Wire)',
  FIAT_INTERNAL_TRANSFER: 'Transferencia interna',
  FILE_NAME_AND_SIZE_TEMPLATE: 'Nombre del archivo {0} - {1}',
  FILL_ALL_ENTRIES_AND_SUBMIT: 'Completa todas las entradas y envía',
  FILL_OUT_DETAILS_FOR_NEW_MEMBER: 'Rellena los detalles para el nuevo miembro',
  FILTER: 'Filtrar',
  FILTER_WITH_COUNT: 'Filtrar ({0})',
  FINANCE_AND_TREASURY: 'Finanzas y Tesorería',
  FIRST_NAME: 'Nombre',
  FIRST_NAME_IS_EMPTY_ERROR: 'El nombre no puede estar vacío',
  FOUR_STEPS_BEFORE_FIRST_PAYMENT: 'Cuatro pasos antes de tu primer pago',
  FROM: 'De',
  FROM_DATE: 'Desde (MM/AA)',
  FUNCTIONALITIES: 'Funcionalidades',
  FUNDING_METHOD: 'Método de financiamiento',
  FUNDING_WITH: 'Financiar con {0}',
  FX_LOCK_DEFAULT_LABEL: 'Estándar (2h)',
  FX_LOCK_DURATION: 'Duración: {0}h',
  FX_LOCK_HOURS: '{0}h',
  FX_LOCK_NO_EXTRA_SPREAD: 'Sin spread adicional',
  FX_LOCK_OPTION: '{0} — {1}',
  FX_LOCK_RATE_SPREAD: '(Spread del bloqueo de tasa: +{0})',
  FX_LOCK_RATE_TOOLTIP: 'El bloqueo de tasa incluye {0}% de spread de divisas',
  FX_LOCK_SPREAD: '+{0}% spread',
  FX_MARKUP_AMOUNT_AFTER_EXCHANGE: 'Monto después del cambio',
  FX_MARKUP_APPLY: 'Aplicar margen',
  FX_MARKUP_BPS_HINT: '100 bps = 1%',
  FX_MARKUP_BPS_LABEL: 'Margen (bps)',
  FX_MARKUP_CUSTOMER_PAYS: 'El cliente paga',
  FX_MARKUP_CUSTOMER_QUOTE_PREVIEW: 'Vista previa de cotización del cliente',
  FX_MARKUP_CUSTOMER_RATE: 'Cotización del cliente',
  FX_MARKUP_CUSTOMER_RATE_TOOLTIP:
    'La tasa de cambio después de tu margen. Algunos medios de pago pueden agregar una tarifa de red — puedes verla en los detalles de la transacción.',
  FX_MARKUP_EARNINGS: 'Ganancias por margen FX',
  FX_MARKUP_FIXED_BASED_ON_INPUT: 'Fijo según tu entrada',
  FX_MARKUP_MODAL_SUBTITLE: 'Establece tu spread para esta transacción.',
  FX_MARKUP_MODAL_TITLE: 'Agregar margen FX',
  FX_MARKUP_OUR_SPREAD: '(Nuestro spread: +{0})',
  FX_MARKUP_RATE_BREAKDOWN: 'Desglose de cotización FX',
  FX_MARKUP_TOTAL_SPREAD: '{0} spread total',
  FX_MARKUP_YOUR_SPREAD: '(Tu spread: +{0})',
  FX_MARKUP_YOU_EARN: 'Tú ganas',
  FX_RATE_LOCK: 'Duración del bloqueo de tasa',
  FX_RATE_LOCK_DESCRIPTION:
    'Bloquea tu tipo de cambio por más tiempo. Los bloqueos más largos tienen un spread mayor.',
  GENERATE_STATEMENT_DESCRIPTION:
    'Selecciona una cuenta y un período. El estado de cuenta incluye los saldos inicial y final.',
  GENERATE_STATEMENT_TITLE: 'Generar un estado de cuenta',
  GET_HELP: 'Obtener ayuda',
  GLOBAL_BUSINESS_ACCOUNTS: 'Cuentas empresariales globales en USDC',
  GLOBAL_MERCHANT_SETTLEMENT: 'Liquidación de Comercio Global',
  GLOBAL_MERCHANT_SETTLEMENT_DESC: 'Pagos instantáneos para marketplaces, e-commerce y plataformas',
  GOT_IT: 'Entendido',
  GROSS_AMOUNT: 'Monto bruto',
  HELP: 'Ayuda',
  HIDE: 'Ocultar',
  HIDE_PASSWORD: 'Ocultar contraseña',
  HIDE_ROLE_DETAILS: 'Ocultar detalles del rol',
  HOME: 'Inicio',
  HOUR: 'hora',
  HOURS: 'horas',
  HOW_IT_WORKS_USD_ACCOUNTS_1: 'Obtén detalles ACH / Wire / SWIFT para recibir depósitos USD',
  HOW_IT_WORKS_USD_ACCOUNTS_2: 'Envía pagos a tu nombre',
  HOW_IT_WORKS_USD_ACCOUNTS_3: 'Crea múltiples cuentas para automatizar la conciliación',
  HOW_IT_WORKS_USD_ACCOUNTS_DESC: 'Agrega datos bancarios para recibir y enviar USD a tu nombre.',
  HOW_IT_WORKS_USD_ACCOUNTS_TITLE: 'Detalles de cuenta USD',
  HOW_IT_WORKS_USD_BALANCE_1:
    'Fondea USD desde depósitos locales (SPEI/Pix) o desde tus saldos Caliza USDC/USDT',
  HOW_IT_WORKS_USD_BALANCE_2: 'Envía pagos desde tu saldo USD (remitente: Caliza)',
  HOW_IT_WORKS_USD_BALANCE_3: 'Sin detalles de cuenta USD para depósitos ACH / Wire / SWIFT',
  HOW_IT_WORKS_USD_BALANCE_DESC: 'Mantén USD y envía pagos a todo el mundo.',
  HOW_IT_WORKS_USD_BALANCE_TITLE: 'Saldo USD',
  HOW_NAMED_PAYMENTS_WORK_BODY:
    'Los pagos enviados a nombre de tu cliente requieren datos de cuenta USD para ese cliente. Si aún no se han creado datos de cuenta USD, el cliente aún puede financiar pagos desde su saldo USD, pero el destinatario verá tu nombre en el pago.',
  HOW_NAMED_PAYMENTS_WORK_TITLE: 'Cómo funcionan los pagos nominales',
  HOW_THIS_WORKS: 'Cómo funciona',
  IBAN: 'IBAN',
  IBAN_ACCOUNT_NUMBER: 'IBAN / Número de cuenta',
  IBAN_DETAILS: 'IBAN',
  IBAN_VALIDATION_INVALID_ACCOUNT_NUMBER: 'Número de cuenta inválido',
  IBAN_VALIDATION_INVALID_COUNTRY: 'IBAN inválido del país {0}, para el país {1}',
  IBAN_VALIDATION_INVALID_FORMAT: 'Formato IBAN inválido',
  IBAN_VALIDATION_INVALID_IBAN: 'IBAN inválido',
  IBAN_VALIDATION_NOT_FOUND: 'No se encontró un banco para este IBAN',
  IBAN_VALIDATION_TOO_SHORT_4: 'Debe tener más de 4 caracteres',
  IDENTIFIER: 'Identificador',
  IDP_LINK_ALREADY_VERIFIED: 'Si ya verificaste el correo electrónico en otro navegador',
  IDP_LINK_CONTINUE_SUFFIX: 'para continuar.',
  IDP_LINK_EMAIL_SENT_PREFIX:
    'Un correo electrónico con instrucciones para vincular la cuenta de {0}',
  IDP_LINK_EMAIL_SENT_SUFFIX: 'con tu cuenta del Dashboard de Caliza fue enviado a tu dirección.',
  IDP_LINK_NOT_RECEIVED: '¿No recibiste un código de verificación en tu correo electrónico?',
  IDP_LINK_RESEND_SUFFIX: 'para reenviar el correo electrónico.',
  IDP_LINK_TITLE: 'Vincular {0}',
  IDP_LINK_USER_EXISTS:
    'Ya existe un usuario con el correo electrónico {0}. ¿Cómo quieres continuar?',
  IDP_LINK_VERIFY_EMAIL:
    'Necesitas verificar tu correo electrónico para vincular tu cuenta con {0}',
  'ID_#': 'ID #',
  IFSC_CODE: 'Código IFSC',
  INCOMPLETE_STATUS: 'Incompleto',
  INCORRECT_CODE: 'Código incorrecto. Por favor, inténtalo de nuevo',
  INCORRECT_EMAIL_PASSWORD: 'Correo electrónico o contraseña incorrectos',
  INDIVIDUAL: 'Individuo',
  INFORMATION_FOR_PAYMENT_BENEFICIARY_OR_RECIPIENT:
    'Información para beneficiario o destinatario del pago',
  INITIATOR_AWAITING_APPROVAL_HINT:
    'Un compañero de equipo revisará esta transacción. No puedes aprobar ni rechazar tu propia transacción.',
  INITIATOR_AWAITING_APPROVAL_QUOTE_HINT:
    'Un compañero de equipo revisará esta transacción y actualizará la cotización si expira. No puedes aprobar ni rechazar tu propia transacción.',
  INSTALL_AUTHENTICATOR_APP: 'Instala una aplicación autenticadora',
  INSTALL_AUTHENTICATOR_APP_DESCRIPTION: 'Descarga e instala una aplicación autenticadora como {0}',
  INSTANT_GLOBAL_PAYMENTS: 'Pagos globales instantáneos',
  INSUFFICIENT_FUNDS: 'Fondos insuficientes',
  INTEGRATOR_EARNINGS_SUBTITLE:
    'Rastrea tus ganancias de markup, consulta detalles de transacciones y gestiona liquidaciones',
  INTERNAL_NOTES_DESCRIPTION:
    'Puedes ver adjuntos y notas en tu actividad para referencia futura. Esto es solo para tus ojos.',
  INTERNAL_NOTES_OPTIONAL: 'Notas internas (Opcional)',
  INTERNAL_TRANSFER: 'Transferencia interna',
  INTERNAL_TRANSFER_ACTION: 'Transferencia interna',
  INTERNAL_TRANSFER_COMPLETED: 'Transferencia interna completada',
  INTERNAL_TRANSFER_COMPLETED_DESCRIPTION:
    'Los fondos se movieron entre tus billeteras. El saldo del destinatario se actualizará en breve.',
  INTERNAL_TRANSFER_DIRECTION: 'Dirección',
  INTERNAL_TRANSFER_FROM_CUSTOMER: 'Desde cliente',
  INTERNAL_TRANSFER_FROM_CUSTOMER_DESCRIPTION: 'Cliente → master',
  INTERNAL_TRANSFER_NOTES: 'Notas internas de transferencia o memo',
  INTERNAL_TRANSFER_TO_CUSTOMER: 'Hacia cliente',
  INTERNAL_TRANSFER_TO_CUSTOMER_DESCRIPTION: 'Master → cliente',
  INTERNATIONAL_PAYROLL: 'Nómina Internacional',
  INTERNATIONAL_PAYROLL_DESC: 'Paga a tu fuerza laboral internacional en USDC',
  INVALID_OTP: 'Código inválido. Por favor intenta de nuevo.',
  INVALID_SWIFT_CODE_FOR_IBAN: 'El código Swift no coincide con el IBAN',
  INVITATION_EXPIRED: 'Invitación vencida',
  INVITATION_RESENT: 'Invitación enviada de nuevo',
  INVITATION_REVOKED: 'Invitación revocada',
  INVITATION_SENT: 'Invitación enviada',
  INVITATION_SENT_SUCCESS: 'Invitación enviada',
  INVITE: 'Invitar',
  INVITED_ON: 'Invitado el {0}',
  INVITE_A_TEAM_MEMBER: 'Invitar a un miembro de la equipo',
  INVITE_SOMEONE_ELSE: 'Invitar a otra persona',
  INVITE_TO_DASHBOARD: 'Invitar al panel',
  INVITE_TO_DASHBOARD_DESCRIPTION:
    '{0} recibirá un correo electrónico con un enlace para crear su contraseña.',
  INVOICES_RECEIPTS_ETC: '(Facturas, recibos, etc)',
  IN_PROGRESS: 'En progreso',
  IOF_WITH_PERCENTAGE: `IOF ({0})`,
  IS_POBO: 'Estoy instruyendo este pago en nombre de mi cliente',
  I_AGREE_TO_THE:
    'Por la presente declaro que la información que estoy proporcionando es veraz y precisa según mi conocimiento y he leído y acepto ',
  JOIN_YOUR_TEAM_ON_CALIZA: 'Únete a tu equipo en Caliza',
  KEEP_ACCOUNT: 'Mantener cuenta',
  KEEP_CONTACT: 'Mantener contacto',
  KEEP_TWO_FACTOR_AUTHENTICATION_ENABLED: 'Mantener 2FA',
  LABEL_OR_TITLE: 'etiqueta',
  LANGUAGE: 'Idioma',
  LAST_NAME: 'Apellido',
  LAST_NAME_IS_EMPTY_ERROR: 'El apellido no puede estar vacío',
  LAST_SIGNED_IN_ON: 'Último acceso el {0}',
  LEADERSHIP_EXECUTIVE: 'Liderazgo / Ejecutivo',
  LEARN_MORE: 'Más información',
  LEAVE_ANYWAY: 'Abandonar de todas formas',
  LEAVE_WITHOUT_HASH_DESC: 'Las operaciones sin hash de transacción tardan más en completarse.',
  LEGAL: 'Legal',
  LEGAL_ENTITY_NAME: 'Nombre de entidad legal',
  LIGHT: 'Claro',
  LINK_ACCOUNT: 'Vincular cuenta',
  LINK_COPIED: 'Enlace copiado correctamente',
  LOADING_PLEASE_WAIT: 'Cargando, por favor espera',
  LOADING_TRANSACTION_STATUS: 'Cargando estado de la transacción',
  LOAD_MORE: 'Cargar más',
  LOGIN_AND_SECURITY: 'Inicio de sesión y seguridad',
  LOG_IN: 'Iniciar sesión',
  MAKE_A_DEPOSIT: 'Hacer un Depósito',
  MAKE_A_TRANSFER: 'Hacer una transferencia',
  MANAGE: 'Administrar',
  MANAGE_PAYMENT_CONTACTS: 'Gestionar contactos de pago',
  MANAGE_PAYOUTS: 'Gestiona pagos o recibe fondos instantáneamente en stablecoins',
  MANAGE_ROLES: 'Administrar roles',
  MANAGE_TEAM_AND_USERS: 'Gestionar equipo y usuarios',
  MANAGE_USER: 'Administrar usuario',
  MANAGE_USERS: 'Gestionar usuarios',
  MANUAL_ENTRY_OPTION: 'O ingresa esta clave manualmente en tu aplicación autenticadora:',
  MARKUP: 'Margen',
  MARKUP_EARNED: 'Margen ganado',
  MASTER_ACCOUNT: 'Cuenta principal',
  MASTER_CALIZA_ACCOUNT: 'Cuenta Caliza principal ({0})',
  MAX: 'Máximo',
  MEMO_OR_DESTINATION_OPTIONAL: 'Memo or Destination Tag (Optional)',
  METHOD: 'Método',
  MEXICAN_SPEI: 'Pesos mexicanos (SPEI)',
  MID_MARKET_RATE: 'Cotización de mercado',
  MID_MARKET_RATE_SOURCE: 'fuente: XE',
  MINUTES: 'minutos',
  MISSING_INTEGRATOR_INFORMATION: 'Falta información del integrador, por favor complete KYB',
  MISSING_TRADE_DOCUMENT_DETAILS:
    'Los detalles del documento comercial son obligatorios para esta moneda',
  MOBILE_NUMBER: 'Numero de celular',
  MOBILE_WALLET_INFORMATION: 'Información de la billetera móvil',
  MOBILE_WALLET_PROVIDER: 'Proveedor de billetera (opcional)',
  MONTH: 'Mes',
  MORE: '+{0} más',
  MSISDN: 'Número de teléfono de la billetera móvil',
  MXNB_WALLET: 'Billetera MXNB',
  MXN_DEPOSIT_DETAILS_PROVISIONING:
    'Tu cuenta de depósito MXN se está aprovisionando. Inténtalo de nuevo en unos minutos.',
  MYSELF: 'Yo mismo',
  NAME: 'Nombre',
  NATIONAL_ID_OPTIONAL: 'Documento de identidad (opcional)',
  NEW_CONTACT: 'Contacto nuevo',
  NEW_DEVICE_LOGIN_DESCRIPTION: 'Inicios de sesión desde un nuevo dispositivo',
  NEW_DEVICE_LOGIN_LABEL: 'Inicio de sesión en nuevo dispositivo',
  NEW_PASSWORD: 'Nueva contraseña',
  NEXT: 'Siguiente',
  NICKNAME: 'Alias de cuenta',
  NICKNAME_INVALID_CHARACTERS:
    'El apodo solo puede contener letras, numeros, espacios, guiones y guiones bajos',
  NICKNAME_OPTIONAL: 'Alias de la cuenta (opcional)',
  NICKNAME_PLACEHOLDER: 'Alias de cuenta',
  NICKNAME_REQUIRED_ERROR: 'El apodo no puede estar vacío',
  NICKNAME_UPDATED_SUCCESS: 'Apodo actualizado exitosamente',
  NINE_MIN: '9 min',
  NO: 'No',
  NOTIFICATIONS: 'Notificaciones',
  NOT_APPLICABLE: 'N/A',
  NOT_AVAILABLE_FOR_PAYOUTS: 'No disponible para pagos',
  NOT_STARTED: 'No iniciado',
  NO_ACCOUNTS: 'No hay cuentas disponibles',
  NO_ACTIVITY_YET_SUBTITLE: 'Envía o recibe fondos y aparecerán aquí.',
  NO_ACTIVITY_YET_TITLE: 'Aún no hay actividad',
  NO_BALANCES_YET: 'Aún no hay saldos disponibles',
  NO_BENEFICIARIES_YET_MESSAGE: 'Los clientes aprobados aparecerán aquí como beneficiarios.',
  NO_BENEFICIARIES_YET_TITLE: 'Aún no hay beneficiarios',
  NO_CUSTOMERS_YET_TITLE: 'Aún no hay clientes agregados',
  NO_CUSTOMER_ACTIVITY_VERIFICATION_INCOMPLETE:
    'No puedes enviar fondos hasta que la verificación de este cliente esté completa y aprobada.',
  NO_DEPOSIT_OPTIONS_AVAILABLE: 'No hay opciones de depósito disponibles',
  NO_ILL_WAIT: 'No, esperaré',
  NO_ITEMS_FOUND: 'No se encontraron elementos',
  NO_NICKNAME: 'Sin apodo de cuenta',
  NO_NUMBER: 'La contraseña debe tener al menos 1 número',
  NO_PAYMENT_METHODS_AVAILABLE: 'No hay métodos de pago disponibles',
  NO_RECIPIENTS_MATCH_SEARCH: 'Ningún destinatario coincide con tu búsqueda',
  NO_RECIPIENT_ACCOUNTS: 'No hay cuentas de destinatario',
  NO_RESULTS_FOUND: 'No se encontraron resultados',
  NO_SPECIAL_CHARACTER: 'La contraseña debe tener al menos 1 carácter especial',
  NO_USD_ACCOUNTS_YET: 'Aún no hay cuentas USD',
  NUMBER: 'número',
  N_ACCOUNTS: '{0} cuentas',
  ONE_TIME_PASSWORD: 'Verificar con autenticación de dos factores',
  ONE_TIME_PASSWORD_DESCRIPTION:
    'Ingresa el código temporal generado en tu aplicación autenticadora',
  ONLY_CURRENCY_SUPPORTED_BY_COUNTRY: 'Solo {0} son compatibles con este país.',
  OPERATIONS: 'Operaciones',
  OPERATIONS_WITHOUT_A_TRANSACTION_HASH_TAKE_LONGER:
    'Las operaciones sin un hash de transacción tardan más en completarse.',
  OPERATOR: 'Operador',
  OPERATOR_DESCRIPTION:
    'Capacidades de transacción, ver y descargar historial de transacciones y reportes de actividad',
  OPTIONAL: 'Opcional',
  OR: 'O',
  ORIGINAL_TRANSACTION: 'ID# de la transacción original',
  OTHER: 'Otro',
  OTP_DIGIT: 'Dígito {0}',
  OUTCOME: 'Resultado',
  PASSPORT: 'Passport',
  PASSWORD: 'Contraseña',
  PASSWORDS_DO_NOT_MATCH: 'Las contraseñas no coinciden',
  PASSWORD_DOES_NOT_MEET_REQUIREMENTS: 'La contraseña no cumple los requisitos',
  PASSWORD_IS_EMPTY_ERROR: 'La contraseña no puede estar vacía',
  PASSWORD_MINIMUM: 'La contraseña debe tener un mínimo de',
  PAYMENT_APPROVALS: 'Aprobaciones de pagos',
  PAYMENT_APPROVAL_AWAITING_DESCRIPTION:
    'Recibe una notificación cuando una transferencia o retiro necesita tu aprobación, o cuando una que enviaste está esperando aprobación',
  PAYMENT_APPROVAL_AWAITING_LABEL: 'Esperando aprobación',
  PAYMENT_APPROVAL_DECISION_DESCRIPTION:
    'Recibe una notificación cuando una transferencia o retiro que enviaste sea aprobado o rechazado',
  PAYMENT_APPROVAL_DECISION_LABEL: 'Aprobado o rechazado',
  PAYMENT_APPROVAL_MISCONFIG_WARNING:
    'Las reglas de aprobación están activas, pero tu organización no tiene un aprobador elegible además de ti. Otorga el permiso de aprobación a otro miembro del equipo para que las transacciones puedan aprobarse.',
  PAYMENT_APPROVAL_MISCONFIG_WARNING_NO_ACCESS:
    'Las reglas de aprobación están activas, pero tu organización no tiene un aprobador elegible además de ti. Pide a un administrador que otorgue el permiso de aprobación a otro miembro del equipo para que las transacciones puedan aprobarse.',
  PAYMENT_APPROVAL_NO_APPROVER_ALERT:
    'Esta transacción coincide con una regla de aprobación ({0}), pero tu organización no tiene un aprobador elegible además de ti. Un administrador debe otorgar el permiso de aprobación a otro miembro del equipo o desactivar la regla.',
  PAYMENT_APPROVAL_OPERATOR_GT: 'Mayor que',
  PAYMENT_APPROVAL_RULES_DESCRIPTION:
    'Retén transferencias y retiros para aprobación cuando se cumpla una condición.',
  PAYMENT_APPROVAL_RULES_EMPTY: 'Aún no hay reglas de aprobación.',
  PAYMENT_APPROVAL_RULES_LABEL: 'Reglas de aprobación de pagos',
  PAYMENT_APPROVAL_STATUS: 'Aprobaciones de pagos',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT: 'Monto debitado',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT_CONDITION: 'Si el monto es mayor que',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT_DESCRIPTION:
    'El monto que sale del saldo de tu billetera Caliza cuando se ejecuta la transacción, antes de cualquier conversión.',
  PAYMENT_BENEFICIARY_INFO: 'Información para beneficiario o destinatario del pago',
  PAYMENT_COMPLETED: 'Pago completado',
  PAYMENT_COMPLETED_DESC: 'Su pago ha sido completado.',
  PAYMENT_IDENTIFIERS: 'Identificadores de Pago',
  PAYMENT_INSTRUCTIONS: 'Instrucciones de Pago',
  PAYMENT_METHOD: 'Método de pago',
  PAYMENT_METHODS: 'Métodos de pago',
  PAYMENT_METHODS_FETCH_ERROR: 'Ocurrió un error al intentar obtener los métodos de pago.',
  PAYMENT_METHOD_TITLE: 'Método de pago',
  PAYMENT_RAIL_ACH_WIRE: 'ACH y Wire',
  PAYMENT_RAIL_FEE: 'Tarifa {0}',
  PAYMENT_RAIL_RTP: 'RTP',
  PAYMENT_RAIL_SWIFT: 'SWIFT',
  PAYMENT_REFERENCE: 'Referencia de pago (máximo 35 caracteres)',
  PAYMENT_REFERENCE_DESCRIPTION:
    'Esta es una referencia opcional de pago para que tu destinatario vea y verifique tu transferencia.',
  PAYMENT_REFERENCE_DETAILS_LABEL: 'Referencia de pago',
  PAYMENT_REFERENCE_LABEL: 'Referencia de pago (máximo 200 caracteres)',
  PAYMENT_SENT: 'Pago enviado',
  PAYMENT_SENT_DESC: 'Su pago ha sido enviado.',
  PAYMENT_SENT_DESCRIPTION:
    'Recibe notificaciones cuando una transferencia esté en progreso, en camino al destinatario',
  PAYMENT_SENT_LABEL: 'Pago enviado',
  PAYMENT_UNDER_REVIEW: 'Pago Bajo Revisión',
  PAYMENT_UNDER_REVIEW_DESC: 'Su pago está siendo revisado para cumplimiento.',
  PAYOR: 'Pagador',
  PAYOUT_SUPPORTED: 'Pago habilitado',
  PENDING: 'Pendiente',
  PENDING_ACAM_220_FILE_ALERT: 'Todavía estamos esperando que envíe su archivo ACAM 220.',
  PENDING_ACAM_220_FILE_ALERT_TRANSACTIONS_LIST_ACTION:
    'Vea los detalles de la transacción para completar.',
  PENDING_ACAM_220_FILE_ALERT_TRANSACTION_DETAILS_DRAWER_ACTION:
    'Por favor, haga clic en "Detalles" a continuación para cargar el archivo.',
  PENDING_APPROVALS_BANNER_PLURAL: 'Tienes {0} pagos pendientes de aprobación.',
  PENDING_APPROVALS_BANNER_SINGULAR: 'Tienes 1 pago pendiente de aprobación.',
  PENDING_DESC: 'Su pago está procesándose',
  PERMISSIONS: 'Permisos',
  PERMISSION_SEND_PAYMENTS: 'Enviar pagos y convertir',
  PERMISSION_SEND_PAYMENTS_HINT_OFF: 'Marca para acceso completo',
  PERMISSION_SEND_PAYMENTS_HINT_ON: 'Desmarca para acceso de solo lectura',
  PERMISSION_VIEW: 'Ver saldos, actividad y destinatarios',
  PERMISSION_VIEW_HINT: 'Siempre incluido',
  PERSONAL_INFORMATION: 'Información personal',
  PIX: 'Pix',
  PIX_DEPOSIT_DESCRIPTION:
    'Una vez que estés en tu aplicación bancaria, usa el enlace a continuación para completar tu depósito usando Pix. Te enviaremos una confirmación por correo electrónico una vez que se reciba tu depósito.',
  PIX_KEY: 'Clave PIX',
  PIX_KEY_DETAILS: 'Clave Pix',
  PREFERRED_LANGUAGE: 'Idioma preferido',
  PREVIEW: 'Vista previa',
  PRIVACY_POLICY: 'Política de Privacidad',
  PROCEED_WITH_ACTION: 'Continuar con la acción',
  PROCESSED_BY_BANK: 'Procesado por el Banco',
  PROCESSED_BY_BANK_DESC: 'Su pago ha sido procesado por el banco emisor.',
  PROCESSED_BY_INTERMEDIARY_BANK: 'Procesado por Banco Intermediario',
  PROCESSED_BY_INTERMEDIARY_BANK_DESC: 'Su pago ha sido procesado por el banco intermediario.',
  PROCESSING: 'Procesando',
  PROCESSING_DESC: 'Su pago está siendo procesado.',
  PRODUCT_AND_TECHNOLOGY: 'Producto y Tecnología',
  PRODUCT_CATEGORY_APPAREL: 'Ropa',
  PRODUCT_CATEGORY_AUTOMOTIVE: 'Automotriz',
  PRODUCT_CATEGORY_COSMETICS: 'Cosméticos',
  PRODUCT_CATEGORY_ELECTRONICS: 'Electrónica',
  PRODUCT_CATEGORY_FOOD_AND_BEVERAGE: 'Alimentos y Bebidas',
  PRODUCT_CATEGORY_FURNITURE: 'Muebles',
  PRODUCT_CATEGORY_MACHINERY: 'Maquinaria',
  PRODUCT_CATEGORY_OTHER: 'Otros',
  PRODUCT_CATEGORY_RAW_MATERIALS: 'Materias Primas',
  PRODUCT_CATEGORY_TEXTILES: 'Textiles',
  PRODUCT_CATEGORY_TOYS: 'Juguetes',
  PROFILE: 'Perfil',
  PROVIDE_THE_SIX_DIGIT_CODE: 'Proporciona el código de 6 dígitos de tu aplicación autenticadora',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_DESCRIPTION:
    'Capital social, transferencias de fondos',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_LABEL: 'Inyección de Capital / Inversión',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_DESCRIPTION: 'Comisiones de ventas, corretaje',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_LABEL: 'Comisiones y Honorarios de Agentes',
  PURPOSE_OF_TRANSFER_EFX_OPERATION_DESCRIPTION: 'ACAM220 para operación eFX',
  PURPOSE_OF_TRANSFER_EFX_OPERATION_LABEL: 'Operación eFX',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_DESCRIPTION: 'Entre entidades relacionadas',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_LABEL: 'Transferencias Intercompañía',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_DESCRIPTION:
    'Bienes y servicios de proveedores',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_LABEL: 'Pagos de Facturas y Proveedores',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_DESCRIPTION: 'Pagos de PI, software, patentes',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_LABEL: 'Licencias y Regalías',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_DESCRIPTION: 'Pagos de préstamos comerciales',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_LABEL: 'Pago de Préstamos e Intereses',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_DESCRIPTION: 'Flete, aduanas, almacenaje',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_LABEL: 'Logística y Envíos',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_DESCRIPTION:
    'Anuncios digitales, campañas, agencias',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_LABEL: 'Marketing y Publicidad',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_DESCRIPTION: 'Alquiler, servicios públicos, seguros',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_LABEL: 'Gastos Operativos',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_DESCRIPTION: 'Salarios, sueldos, freelancers',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_LABEL: 'Nómina y Pagos a Contratistas',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_DESCRIPTION:
    'Honorarios de consultoría, legales, contables',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_LABEL: 'Servicios Profesionales',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_DESCRIPTION: 'IVA, aduanas, regulatorio',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_LABEL:
    'Impuestos, Aranceles y Tasas Gubernamentales',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_DESCRIPTION: 'SaaS, nube, infraestructura TI',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_LABEL: 'Servicios Tecnológicos',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_DESCRIPTION: 'Cartas de crédito, liquidaciones comerciales',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_LABEL: 'Financiamiento Comercial',
  QR_CODE: 'Código QR',
  QR_CODE_NOT_AVAILABLE: 'Código QR no disponible',
  QUOTE_EXPIRED: 'Expirada',
  QUOTE_EXPIRED_DESCRIPTION: 'Actualiza para aprobar a la tasa actual.',
  QUOTE_EXPIRED_TITLE: 'Esta cotización expiró',
  QUOTE_EXPIRES_IN: 'Expira en',
  QUOTE_ORIGINAL_MID_MARKET_RATE: 'Cotización de mercado original: {0}',
  QUOTE_ORIGINAL_VALUE: 'Originalmente {0}',
  QUOTE_REFRESH: 'Actualizar cotización',
  QUOTE_REFRESH_ERROR: 'No se pudo actualizar la cotización. Inténtalo de nuevo.',
  QUOTE_WILL_EXPIRE: 'Esta cotización expirará en',
  REACTIVATE: 'Reactivar',
  REACTIVATE_BLOCKED_BY_ACTIVE_USER:
    'Desactiva el usuario actual del dashboard antes de restaurar este acceso.',
  REACTIVATE_BLOCKED_BY_INVITATION:
    'Revoca la invitación pendiente antes de restaurar este acceso.',
  RECEIVED_BY_BENEFICIARY_BANK: 'Recibido por Banco Beneficiario',
  RECEIVED_BY_BENEFICIARY_BANK_DESC: 'Su pago ha sido recibido por el banco beneficiario.',
  RECEIVED_BY_INTERMEDIARY_BANK: 'Recibido por Banco Intermediario',
  RECEIVED_BY_INTERMEDIARY_BANK_DESC: 'Su pago ha sido recibido por el banco intermediario.',
  RECEIVE_AND_SEND_USD: 'Recibe y envía USD usando tu propio número de cuenta y enrutamiento',
  RECIPIENT: 'Destinatario',
  RECIPIENTS: 'Destinatarios',
  RECIPIENTS_WALLET: "Recipient's wallet address",
  RECIPIENT_ADDRESS: 'Dirección del destinatario',
  RECIPIENT_DETAILS: 'Detalles del destinatario',
  RECIPIENT_EMAIL: 'Correo electrónico del destinatario',
  RECIPIENT_GETS: 'El destinatario recibe',
  RECIPIENT_ID: 'ID del destinatario',
  RECIPIENT_ID_TYPE: 'Tipo de ID del Destinatario',
  RECIPIENT_INFORMATION: 'Información del destinatario',
  RECIPIENT_MEMO: 'Memo del destinatario',
  RECIPIENT_MEMO_OPTIONAL: 'Memo del destinatario (Opcional)',
  RECIPIENT_NOT_FOUND: 'Destinatario no encontrado',
  RECIPIENT_TYPE: 'Tipo de destinatario',
  REFERENCE: 'Referencia',
  REFUND: 'Reembolso',
  REFUNDED: 'Reembolsada',
  REFUNDED_ALERT: 'Esta transacción fue reembolsada.',
  REFUNDED_ALERT_ACTION: 'Vea la transacción de reembolso en los detalles.',
  REFUNDED_DESC: 'Tu transacción fue reembolsada.',
  REFUND_TO: 'Reembolso a {0}',
  REFUND_TRANSACTION: 'ID# de la transacción de reembolso',
  REGISTRATION_NUMBER: 'Número de registro',
  REJECT: 'Rechazar',
  REJECTED: 'Rechazada',
  REJECTED_DESC: 'Tu transacción fue rechazada.',
  REMOVE: 'Eliminar',
  REMOVE_USERS_BUTTON_LABEL: 'Eliminar {0}',
  REQUIRED_ACCOUNT: 'Select account to continue',
  REQUIRED_AMOUNT: 'Amount cannot be empty',
  REQUIRED_FUNDING_METHOD: 'Select funding method to continue',
  REQUIRED_RECIPIENT: 'Recipient cannot be empty',
  REQUIRED_SUPPORTING_DOCUMENTATION: 'Supporting documentation is required',
  RESEND: 'Reenviar',
  RESEND_CODE: 'Reenviar código',
  RESEND_INVITE: 'Reenviar invitación',
  RESEND_INVITE_ERROR: 'Error al reenviar la invitación',
  RESEND_INVITE_SUCCESS: 'Invitación reenviada con éxito',
  RESET: 'Restablecer',
  RESETTING: 'Restableciendo...',
  RESET_PASSWORD: 'Restablecer contraseña',
  RESET_PASSWORD_DESCRIPTION: 'Ingresa tu contraseña actual para restablecerla',
  RESET_PASSWORD_FAILED: 'Error al restablecer la contraseña. Por favor, inténtalo de nuevo.',
  RESET_PASSWORD_FORBIDDEN: 'Por favor, proporciona tu contraseña actual para restablecerla.',
  RESET_PASSWORD_SUCCESS: 'Contraseña restablecida exitosamente',
  RESET_PASSWORD_TITLE: 'Restablecer contraseña',
  RESULT: 'Resultado',
  RESUME_VERIFICATION: 'Reanudar verificación',
  RETRY: 'Reintentar',
  RETURNED: 'Devuelta',
  RETURNED_DESC: 'Tu transacción fue devuelta.',
  REVEAL: 'Mostrar',
  REVENUE_EARNINGS: 'Ingresos por comisiones',
  REVERSAL: 'Reversión',
  REVERSAL_TRANSACTION: 'ID# de la transacción de reversión',
  REVERSED: 'Revertida',
  REVERSED_ALERT: 'Este depósito fue revertido.',
  REVERSED_ALERT_ACTION: 'Vea la transacción de reversión en los detalles.',
  REVERSED_DESC: 'Tu depósito fue revertido.',
  REVIEW: 'Revisión',
  REVIEW_AND_SUBMIT: 'Revisar y enviar',
  REVIEW_CONVERSION: 'Revisar conversión',
  REVIEW_PROFILE: 'Revisar perfil',
  REVIEW_STATUS_APPROVED: 'Aprobado',
  REVIEW_STATUS_PENDING_REVIEW: 'Revisión pendiente',
  REVIEW_STATUS_REJECTED: 'Rechazado',
  REVOKE: 'Revocar',
  REVOKE_INVITE: 'Revocar invitación',
  REVOKE_INVITE_DESCRIPTION:
    'La invitación enviada a {0} dejará de funcionar. Puedes enviar una nueva invitación en cualquier momento.',
  REVOKE_INVITE_TITLE: '¿Revocar esta invitación?',
  RISK_AND_COMPLIANCE: 'Riesgo y Cumplimiento',
  ROLE: 'Rol',
  ROLE_APPROVE_OR_REJECT_TRANSACTION: 'Aprobar o rechazar transacciones',
  ROLE_CREATE_TRANSACTIONS: 'Crear transacciones',
  ROLE_CREATE_USD_ACCOUNT: 'Crear cuentas USD',
  ROLE_MANAGE_CUSTOMER: 'Gestionar clientes',
  ROLE_MANAGE_PAYMENT_APPROVAL_RULES: 'Gestionar reglas de aprobación de pagos',
  ROLE_MANAGE_PAYMENT_CONTACTS: 'Gestionar contactos de pago',
  ROLE_MANAGE_USER: 'Administrar equipo y usuarios',
  ROLE_NAME: 'Nombre del rol',
  ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS:
    'Recibir notificaciones de estado de transacciones',
  ROLE_VIEW_ACTIVITY: 'Ver y descargar historial de transacciones y reporte de actividad',
  ROLE_VIEW_BENEFICIARIES: 'Ver cuentas',
  ROLE_VIEW_INTEGRATOR_EARNINGS: 'Ver ganancias',
  ROLE_VIEW_USD_ACCOUNT: 'Ver cuentas USD',
  ROLE_WITHDRAW_INTEGRATOR_EARNINGS: 'Retirar ganancias',
  ROTATE: 'Rotar',
  ROTATE_WEBHOOK_SECRET: 'Rotar secreto de webhook',
  ROTATE_WEBHOOK_SECRET_CONFIRM_DESCRIPTION:
    'Se generará un nuevo secreto de webhook. Tu secreto anterior dejará de funcionar inmediatamente y cualquier integración que dependa de él fallará hasta que la actualices.',
  ROTATE_WEBHOOK_SECRET_CONFIRM_TITLE: '¿Rotar secreto de webhook?',
  ROUTING_CODE_CAD: 'Número de tránsito + institución',
  ROUTING_NUMBER: 'Número de ruta',
  ROUTING_NUMBER_COPIED: 'Número de ruta copiado con éxito',
  ROUTING_NUMBER_DETAILS: 'Número de ruta',
  ROUTING_NUMBER_WITH_CURRENCY: 'Número de ruta ({0})',
  RTP: 'RTP',
  RUNNING: 'En ejecución',
  SALES: 'Ventas',
  SAME_DAY_ACH: 'ACH el mismo día',
  SAMPLE_RESPONSES: 'Respuestas de muestra',
  SAVE: 'Guardar',
  SAVE_AND_CLOSE: 'Guardar y cerrar',
  SAVE_CHANGES: 'Guardar cambios',
  SAVINGS: 'Savings',
  SCAN_QR_CODE: 'Escanea el código QR',
  SEARCH: 'Buscar',
  SEARCH_BY_CURRENCY_OR_RAIL: 'Buscar por moneda o carril',
  SEARCH_BY_NAME: 'Buscar por nombre',
  SEARCH_COUNTRIES: 'Buscar países',
  SEARCH_RECIPIENTS_PLACEHOLDER: 'Busca por nombre, apodo, banco o cuenta',
  SECURE_AND_COMPLIANT: 'Rampas criptográficas seguras y conformes',
  SEE_ACCOUNTS: 'Ver cuentas',
  SEE_ALL: 'Ver todo',
  SEE_DETAILS: 'Ver detalles',
  SELECT_ACCOUNT: 'Seleccionar cuenta',
  SELECT_ALL: 'Seleccionar todo',
  SELECT_CONTACT_TYPE: 'Select contact type',
  SELECT_CUSTOMER: 'Seleccionar cliente',
  SELECT_EXISTING_CONTACT: 'Seleccionar contacto existente',
  SELECT_FILTERS_THAT_APPLY:
    'Selecciona cualquiera de los siguientes filtros para aplicar a tu búsqueda',
  SELECT_FUNDING_CURRENCY: 'Selecciona la moneda de financiamiento',
  SELECT_PAYMENT_METHOD: 'Selecciona un método de pago',
  SELECT_PURPOSE_FOR_TRANSFER: 'Selecciona el propósito de la transferencia',
  SELECT_RECIPIENT: 'Selecciona destinatario',
  SELECT_RECIPIENT_ACCOUNT: 'Selecciona los detalles de la cuenta del destinatario',
  SELECT_RECIPIENT_ACCOUNT_DETAILS: 'Selecciona los detalles de la cuenta del destinatario',
  SELECT_ROLE_FUNCTIONS: 'Selecciona las funciones que tiene este rol:',
  SELECT_TARGET_CURRENCY: 'Moneda destino',
  SELECT_TYPE: 'Seleccionar tipo',
  SELECT_WAYS_TO_USE_CALIZA: 'Selecciona las formas en que planeas usar Caliza',
  SELF_APPROVAL_HINT: 'No puedes aprobar ni rechazar tu propio pago.',
  SENDER: 'Remitente',
  SENDER_INFORMATION: 'Información del Remitente',
  SENDER_NAME_NO_USD_DETAILS:
    'Este cliente no tiene datos de cuenta USD, por lo que tu nombre aparecerá en este pago.',
  SENDER_NAME_SHOWN_TO_RECIPIENT: 'Nombre del remitente visible para el destinatario',
  SEND_FUNDS_FROM_BANK: 'Envía fondos desde tu banco para completar la transferencia',
  SEND_FUNDS_TO_CALIZA_WALLET: 'Envía fondos a tu cuenta Caliza',
  SEND_FUNDS_TO_COMPLETE_TRANSFER: 'Envía fondos para completar la transferencia',
  SEND_INVITATION: 'Enviar invitación',
  SEND_TO_RECIPIENT: 'Enviar al destinatario',
  SETTINGS: 'Configuración',
  SETTINGS_UPDATE_ERROR: 'Error al actualizar la configuración. Por favor, intenta de nuevo.',
  SETTINGS_UPDATE_SUCCESS: 'Configuración actualizada exitosamente',
  SETTLEMENT_CURRENCY: 'Moneda de liquidación',
  SETTLEMENT_INSTANT: 'Instantáneo',
  SETTLEMENT_INSTANT_MARKET_HOURS: 'Instantáneo (durante horario de mercado)',
  SETTLEMENT_ONE_TO_THREE_DAYS: '1-3 días hábiles',
  SETTLEMENT_ONE_TO_TWO_DAYS: '1-2 días hábiles',
  SETTLEMENT_SAME_DAY_BEFORE_CUTOFF: 'Mismo día (si se envía antes del corte diario)',
  SETTLEMENT_TIME: 'Tiempo de liquidación',
  SETTLEMENT_UNKNOWN: 'Tiempo de liquidación no disponible',
  SETTLEMENT_WITHIN_15_MINUTES: 'Normalmente dentro de 15 minutos',
  SETTLEMENT_WITHIN_5_MINUTES: 'Normalmente dentro de 5 minutos',
  SETUP_AUTHENTICATOR: 'Configura tu autenticador',
  SET_NEW_PASSWORD: 'Establecer nueva contraseña',
  SET_YOUR_PASSWORD: 'Crea tu contraseña',
  SET_YOUR_PASSWORD_DESCRIPTION:
    'Tu cuenta está lista. Elige una contraseña para acceder a tu panel.',
  SHARE_TRANSACTION_HASH: 'Compartir hash de transacción',
  SHOW_LESS: 'Mostrar menos',
  SHOW_MORE: 'Mostrar más',
  SHOW_PASSWORD: 'Mostrar contraseña',
  SHOW_ROLE_DETAILS: 'Mostrar detalles del rol',
  SIGN_IN: 'Iniciar sesión',
  SIGN_OUT: 'Cerrar sesión',
  SIGN_UP: 'Registrarse',
  SIGN_UP_WITH_GOOGLE: 'Registrarse con Google',
  SIX_DIGIT_AUTHENTICATOR_CODE: 'Código de autenticador de 6 dígitos',
  SKIP_TWO_FACTOR_VERIFICATION: 'Omitir verificación de dos factores',
  SPECIAL_CHARACTER: 'carácter especial',
  SPEI_BANK_BENEFICIARY: 'Beneficiario',
  SPEI_BANK_NAME: 'Banco',
  SPEI_CLABE_COPIED: 'CLABE copiado.',
  SPEI_DEPOSIT_DESCRIPTION: 'Usa esta CLABE para realizar tu depósito.',
  STABLECOIN_BALANCES: 'Saldos de cuenta del cliente',
  STABLECOIN_WALLET: 'Cartera de stablecoin',
  START_CURRENCY: 'Starting currency',
  START_VERIFICATION: 'Iniciar verificación',
  STATE: 'Estado',
  STATEMENT_DISCLAIMER: 'Los estados de cuenta son generados y proporcionados por Caliza.',
  STATEMENT_FORMAT: 'Formato',
  STATEMENT_FORMAT_CSV: 'Hoja de cálculo CSV (Excel)',
  STATEMENT_FORMAT_PDF: 'Documento PDF',
  STATEMENT_MENU_ITEM: 'Estados de cuenta',
  STATEMENT_PERIOD_ERROR: 'Selecciona un período válido de hasta un año',
  STATUS: 'Estado',
  STEP: 'Paso',
  STREET_ADDRESS: 'Dirección',
  SUBMIT: 'Enviar',
  SUBMITTED: 'Enviado',
  SUCCEEDED: 'Completada',
  SUCCEEDED_DESC: 'Tu transacción se ha completado.',
  SUITE_FLOOR_APT: 'Suite / Piso / Apto',
  SUMMARY: 'Resumen',
  SUPPORTED_ONLY: 'Solo compatibles',
  SUPPORTING_DOCUMENTATION: 'Documentación de respaldo',
  SUPPORTING_DOCUMENTATION_DESCRIPTION:
    'Por razones de cumplimiento, este pago requiere un documento de respaldo, como una factura, contrato o recibo de pago. Esto no será enviado a su destinatario.',
  SWIFT: 'SWIFT',
  SWIFT_CODE: 'Código SWIFT',
  SWIFT_CODE_DETAILS: 'Código Swift',
  SWIFT_CODE_INVALID:
    'El código SWIFT debe tener 6 letras seguidas de 2 o 5 caracteres alfanuméricos',
  SWIFT_CODE_NOT_FOUND: 'No se encontró un banco para este código SWIFT',
  SWIFT_CURRENCY_INSTRUCTED_VERSUS_SETTLEMENT_TOOLTIP:
    'La instrucción de pago se denomina en {0}. No obstante, la moneda de liquidación puede variar dependiendo del banco receptor y tipo de cuenta del destinatario.',
  SWIFT_MINIMUM_AMOUNT: 'El monto mínimo para transferencia SWIFT es 15000 USD',
  SWIFT_TO_WIRE_MORPH_NEEDS_ROUTING:
    'Los pagos a bancos de EE. UU. se envían como transferencias domésticas (wire). Ingresa el número de ruta (ABA) y el número de cuenta de las instrucciones de tu banco.',
  SWIFT_TO_WIRE_MORPH_PREFILLED:
    'Los pagos a bancos de EE. UU. se envían como transferencias domésticas (wire). Hemos completado el número de ruta (ABA) a partir del código SWIFT de tu banco — confírmalo y agrega el número de cuenta.',
  SWIFT_UPDATED_BADGE: 'Actualizado por IBAN',
  SYSTEM_ERROR: 'Algo salió mal. Inténtalo de nuevo.',
  TAX: 'Impuesto ({0})',
  TEN_MIN: '10 min',
  TERMS_ACCEPT_ERROR: 'Debes aceptar los Términos de Servicio y la Política de Privacidad',
  TERMS_OF_SERVICE: 'Términos de Servicio',
  THEME: 'Tema',
  THESE_USERS: 'estos usuarios',
  THIS_ACTION_IS_NOT_REVERSIBLE: 'Esta acción no es reversible.',
  THIS_MONTH: 'Este mes',
  THIS_QUOTE_WILL_REMAIN_ACTIVE_FOR: 'Esta cotización permanecerá activa por',
  THIS_USER: 'este usuario',
  THIS_WEEK: 'Esta semana',
  TIMEZONE_ALASKA_STANDARD_TIME: 'Hora Estándar de Alaska - AKST',
  TIMEZONE_ARGENTINA_TIME: 'Hora de Argentina - ART',
  TIMEZONE_BOLIVIA_TIME: 'Hora de Bolivia - BOT',
  TIMEZONE_BRAZIL_TIME: 'Hora de Brasília - BRT',
  TIMEZONE_CENTRAL_EUROPEAN_TIME: 'Hora Central Europea - CET',
  TIMEZONE_CENTRAL_STANDARD_TIME: 'Hora Estándar Central - CST',
  TIMEZONE_CHILE_TIME: 'Hora Estándar de Chile - CLT',
  TIMEZONE_COLOMBIA_TIME: 'Hora de Colombia - COT',
  TIMEZONE_EASTERN_EUROPEAN_TIME: 'Hora Oriental Europea - EET',
  TIMEZONE_EASTERN_STANDARD_TIME: 'Hora Estándar Oriental - EST',
  TIMEZONE_ECUADOR_TIME: 'Hora de Ecuador - ECT',
  TIMEZONE_GREENWICH_MEAN_TIME: 'Hora Media de Greenwich - GMT',
  TIMEZONE_GUYANA_TIME: 'Hora de Guyana - GYT',
  TIMEZONE_HAWAII_STANDARD_TIME: 'Hora Estándar de Hawái - HST',
  TIMEZONE_MOSCOW_TIME: 'Hora de Moscú - MSK',
  TIMEZONE_MOUNTAIN_STANDARD_TIME: 'Hora Estándar de Montaña - MST',
  TIMEZONE_PACIFIC_STANDARD_TIME: 'Hora Estándar del Pacífico - PST',
  TIMEZONE_PARAGUAY_TIME: 'Hora de Paraguay - PYT',
  TIMEZONE_PERU_TIME: 'Hora de Perú - PET',
  TIMEZONE_SURINAME_TIME: 'Hora de Surinam - SRT',
  TIMEZONE_URUGUAY_TIME: 'Hora de Uruguay - UYT',
  TIMEZONE_VENEZUELA_TIME: 'Hora de Venezuela - VET',
  TIMEZONE_WESTERN_EUROPEAN_TIME: 'Hora Occidental Europea - WET',
  TIME_ZONE: 'Zona horaria',
  TO: 'Para',
  TODAY: 'Hoy',
  TOO_SHORT: 'La contraseña es demasiado corta, debe tener un mínimo de 8 caracteres',
  TOTAL_ACROSS_N_ACCOUNTS: 'Total en {0} cuentas',
  TOTAL_AMOUNT: 'Monto total',
  TOTAL_EARNINGS: 'Ganancias totales (histórico)',
  TOTAL_FEES: 'Total de comisiones',
  TOTAL_USD_BALANCE: 'Balance total en USD',
  TOTP_APP_FREEOTP_NAME: 'FreeOTP',
  TOTP_APP_GOOGLE_NAME: 'Google Authenticator',
  TOTP_APP_MICROSOFT_AUTHENTICATOR_NAME: 'Microsoft Authenticator',
  TOTP_DISABLED_ERROR: 'Ocurrió un error al deshabilitar la autenticación de dos factores',
  TOTP_DISABLED_SUCCESS: 'Autenticación de dos factores deshabilitada con éxito',
  TOTP_ENABLED_FAILED: 'Ocurrió un error al habilitar la autenticación de dos factores',
  TOTP_ENABLED_SUCCESS: 'Autenticación de dos factores habilitada con éxito',
  TOTP_STEP_1: 'Abre una aplicación de autenticación como Google Authenticator o FreeOTP',
  TOTP_STEP_2: 'Escanea el código QR usando la aplicación de autenticación',
  TOTP_STEP_3: 'Ingresa el código temporal generado con tu aplicación de autenticación',
  TO_DATE: 'Hasta (MM/AA)',
  TO_DATE_CANNOT_BE_AFTER_TODAY: 'La fecha final no puede ser posterior a la fecha de hoy',
  TO_DATE_MUST_BE_AFTER_FROM_DATE: 'La fecha final debe ser posterior a la fecha inicial',
  TRADE_DOCUMENT_ADD_PRODUCT: 'Agregar producto',
  TRADE_DOCUMENT_CUSTOMS_DECLARATION_NO: 'Número de declaración aduanera',
  TRADE_DOCUMENT_DETAILS_TITLE: 'Detalles del documento comercial',
  TRADE_DOCUMENT_LOGISTICS_COMPANY: 'Empresa de logística',
  TRADE_DOCUMENT_LOGISTICS_ORDER_NO: 'Número de orden logística',
  TRADE_DOCUMENT_PRODUCTS_TITLE: 'Productos',
  TRADE_DOCUMENT_PRODUCT_CATEGORY: 'Categoría del producto',
  TRADE_DOCUMENT_PRODUCT_NAME: 'Nombre del producto',
  TRADE_DOCUMENT_QUANTITY: 'Cantidad',
  TRADE_DOCUMENT_REMOVE_PRODUCT: 'Eliminar producto',
  TRADE_DOCUMENT_SHIP_DATE: 'Fecha de envío (opcional)',
  TRANSACTIONS_CSV_MENU_ITEM: 'Transacciones (CSV)',
  TRANSACTION_ACH_EFFECTIVE_DATE: 'Fecha efectiva',
  TRANSACTION_ACH_SEC_CODE: 'Código SEC',
  TRANSACTION_ACH_TRACE_NUMBER: 'Número de rastreo ACH',
  TRANSACTION_APPROVAL_ERROR: 'No se pudo enviar la decisión. Inténtalo de nuevo.',
  TRANSACTION_APPROVED_SUCCESS: 'Transacción aprobada',
  TRANSACTION_CONFIRMATION: 'Confirmación de transacción',
  TRANSACTION_DETAILS: 'Detalles de la transacción',
  TRANSACTION_DETAILS_TITLE: 'Detalles de la transacción',
  TRANSACTION_HASH: 'Hash de transacción',
  TRANSACTION_ID: 'ID de transacción#',
  TRANSACTION_IMAD: 'IMAD',
  TRANSACTION_NOT_AWAITING_APPROVAL_ERROR: 'Esta transacción ya no está pendiente de aprobación.',
  TRANSACTION_NOT_FOUND: 'Transacción no encontrada',
  TRANSACTION_OMAD: 'OMAD',
  TRANSACTION_PACS008: 'PACS008',
  TRANSACTION_REJECTED_SUCCESS: 'Transacción rechazada',
  TRANSACTION_TYPE: 'Tipo de transacción',
  TRANSACTION_UETR: 'UETR',
  TRANSFER: 'Transferencia',
  TRANSFER_ACTION: 'Transferir',
  TRANSFER_CREATED_DESCRIPTION: 'Recibe notificaciones cuando una transferencia haya sido creada',
  TRANSFER_CREATED_LABEL: 'Creada',
  TRANSFER_FEES_FREE: 'Comisiones de transferencia (Gratis)',
  TRANSFER_FEES_WITH_PERCENTAGE: 'Comisiones de transferencia ({0})',
  TRANSFER_FUNDS: 'Transferir fondos',
  TRANSFER_RECEIVED: 'Hemos recibido tu pago e iniciado tu transferencia',
  TRANSFER_STATUS: 'Estado de la transferencia',
  TRANSFER_TO: 'Transferencia a {0}',
  TRAVEL_RULE_BENEFICIARY_VASP: 'VASP del beneficiario',
  TRAVEL_RULE_COLLECTION_INCOMPLETE:
    'La conexión con la billetera terminó sin una firma verificada. Inténtalo de nuevo.',
  TRAVEL_RULE_COLLECTION_TIMEOUT: 'La verificación no se completó a tiempo. Inténtalo de nuevo.',
  TRAVEL_RULE_POPUP_BLOCKED:
    'Tu navegador bloqueó la ventana de verificación. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.',
  TRAVEL_RULE_PROOF_REQUIRED: 'Se requiere verificación de titularidad de la billetera',
  TRAVEL_RULE_PROOF_REQUIRED_FIRST_PARTY_INFO:
    'Las regulaciones exigen una comprobación única de que eres el titular de esta billetera auto-alojada antes de enviarle fondos. Conecta la billetera y firma un mensaje — toma un minuto y no cuesta nada.',
  TRAVEL_RULE_PROOF_REQUIRED_THIRD_PARTY_INFO:
    'Las regulaciones exigen que el titular de esta billetera auto-alojada compruebe la titularidad de la dirección antes de que puedas enviarle fondos. Inicia una transferencia de prueba y comparte las instrucciones con el dueño de la billetera.',
  TRAVEL_RULE_SIGN_INSTEAD: '¿Prefieres firmar? Verifica con la firma de tu billetera',
  TRAVEL_RULE_START_TEST: 'Verificar con una transferencia de prueba',
  TRAVEL_RULE_STATUS_CHECK_FAILED:
    'No se pudo consultar el estado de verificación de la billetera. Inténtalo de nuevo.',
  TRAVEL_RULE_TEST_AMOUNT: 'Monto exacto ({0})',
  TRAVEL_RULE_TEST_AUTO_VERIFY:
    'La verificación es automática en cuanto llegue el depósito. Cuando veas el monto de la prueba acreditado en tu saldo, actualiza el estado aquí.',
  TRAVEL_RULE_TEST_CREDITED:
    'El monto de la prueba se acredita en el saldo de tu cuenta al recibirse.',
  TRAVEL_RULE_TEST_DESTINATION: 'Dirección de destino',
  TRAVEL_RULE_TEST_FROM_WALLET:
    'La transferencia debe salir de la billetera en verificación ({0}), en la red {1} — transferencias desde exchanges o cualquier otra dirección no serán reconocidas.',
  TRAVEL_RULE_TEST_INSTRUCTIONS:
    'Para comprobar la titularidad, envía el monto exacto de abajo a la dirección de destino antes de {0}.',
  TRAVEL_RULE_TEST_PENDING: 'Transferencia de prueba pendiente',
  TRAVEL_RULE_TEST_REFRESH: 'Actualizar estado',
  TRAVEL_RULE_TEST_SHARE:
    'Comparte estas instrucciones con el dueño de la billetera — solo él puede enviar desde ella.',
  TRAVEL_RULE_VASP_DID: 'DID del VASP',
  TRAVEL_RULE_VASP_DID_COPIED: 'DID del VASP copiado con éxito',
  TRAVEL_RULE_VERIFY_NOW: 'Verificar con firma de la billetera',
  TREASURY_MANAGEMENT: 'Gestión de Tesorería',
  TREASURY_MANAGEMENT_DESC:
    'Optimiza las operaciones de tesorería internacional y los saldos de efectivo',
  TRY_CHANGING_YOUR_APPLIED_FILTERS: 'Intenta cambiar tus filtros aplicados para ver más {0}.',
  TWELVE_CHARACTERS: 'doce caracteres',
  TWO_FACTOR_AUTHENTICATION: 'Escanea el código QR para obtener el código',
  TWO_FACTOR_AUTHENTICATION_DESCRIPTION:
    'Te recomendamos configurar una aplicación autenticadora para proteger mejor tu cuenta',
  TWO_FACTOR_AUTHENTICATION_SECTION_DESCRIPTION:
    'Configura la autenticación de dos factores con una aplicación autenticadora para proteger tu cuenta',
  TWO_FACTOR_AUTHENTICATION_SECTION_LABEL: 'Autenticación de dos factores',
  TWO_FACTOR_AUTHENTICATION_SETUP: 'Configurar autenticación de dos factores',
  TWO_FACTOR_AUTHENTICATION_SETUP_DESCRIPTION:
    'Te recomendamos configurar una aplicación autenticadora para proteger mejor tu cuenta',
  TWO_FACTOR_AUTHENTICATION_SETUP_SECRET: 'O ingresa esta clave secreta manualmente',
  TWO_FACTOR_DISABLED_ERROR: 'Ocurrió un error al deshabilitar la autenticación de dos factores',
  TWO_FACTOR_DISABLED_SUCCESS: 'Autenticación de dos factores deshabilitada con éxito',
  TWO_FACTOR_RESET_ERROR:
    'Error al restablecer la autenticación de dos factores. Inténtalo de nuevo.',
  TWO_FACTOR_RESET_SUCCESS:
    'La autenticación de dos factores se ha restablecido exitosamente. Serás desconectado en breve.',
  TYPE: 'Tipo',
  UNKNOWN: 'Desconocido',
  UNKNOWN_ERROR: 'Error desconocido',
  UNSET: '(No establecido)',
  UPDATE: 'Actualizar',
  UPDATE_ACCOUNT_INFORMATION: 'Actualizar información de la cuenta',
  UPDATE_CONTACT_SUCCESS: 'Contacto actualizado con éxito',
  UPDATE_EMAIL_ADDRESS_DESCRIPTION:
    'Confirmación cuando actualices tu dirección de correo electrónico para tu cuenta',
  UPDATE_EMAIL_ADDRESS_LABEL: 'Dirección de correo electrónico actualizada',
  UPDATE_PAYMENT_METHOD_SUCCESS: 'Método de pago actualizado con éxito',
  UPLOAD_DOCUMENT: 'Subir documento',
  UPLOAD_DOCUMENTS_NOT_ALLOWED: 'Esta transacción ya no puede aceptar documentos.',
  UPLOAD_ERROR_MESSAGE: 'Error al cargar el archivo. Por favor, intenta de nuevo.',
  UPLOAD_FILE_TOO_LARGE: 'Cada archivo debe ser de 10 MB o menos.',
  UPLOAD_SUCCESS_MESSAGE: 'Archivo cargado exitosamente',
  USDC_AND_USDT: 'Rampas de entrada y salida de USDC y USDT para empresas de todos los tamaños',
  USDC_LABEL: 'USDC',
  USDC_WALLET: 'Billetera USDC',
  USDT_WALLET: 'Billetera USDT',
  USD_ACCOUNT: 'Cuenta USD',
  USD_ACCOUNTS: 'Detalles de cuenta USD',
  USD_ACCOUNT_BENEFIT_1: 'Recibe USD mediante ACH, Wire, RTP o SWIFT con datos de cuenta únicos',
  USD_ACCOUNT_BENEFIT_2: 'Realiza pagos nominados en nombre de tu cliente',
  USD_ACCOUNT_BENEFIT_3: 'Mantén saldos en USD sin necesidad de conversión',
  USD_ACCOUNT_CERT_AUTHORITY:
    'Certifico que {0} está debidamente autorizada por Caliza Financial Technologies, Inc. para abrir y administrar esta Cuenta Virtual USD de Caliza, incluyendo cualquier consentimiento, aprobación y autorización regulatoria requerida (cuando corresponda).',
  USD_ACCOUNT_CERT_AUTHORITY_LABEL: 'Autoridad',
  USD_ACCOUNT_CERT_CUSTOMER_ONLY_USE:
    'Certifico que esta cuenta se usará solo para transacciones y fondos de Caliza Financial Technologies, Inc., y no para terceros o actividades no relacionadas (incluyendo mezcla de fondos).',
  USD_ACCOUNT_CERT_CUSTOMER_ONLY_USE_LABEL: 'Uso exclusivo del cliente',
  USD_ACCOUNT_CERT_LAWFUL_USE:
    'Certifico que los fondos son lícitos y conocidos, esta cuenta se usará solo para actividades permitidas por Caliza, y ningún fondo o actividad involucra personas o entidades ilícitas o sancionadas, según la {0} de Caliza.',
  USD_ACCOUNT_CERT_LAWFUL_USE_LABEL: 'Uso Autorizado y Legal',
  USD_ACCOUNT_CERT_LAWFUL_USE_LINK: 'Política AML',
  USD_ACCOUNT_CERT_TERMS:
    'Certifico que he leído los {0} y la {1} de Caliza en su totalidad y acepto estar obligado por ellos.',
  USD_ACCOUNT_CERT_TERMS_LABEL: 'Términos y Condiciones',
  USD_ACCOUNT_CERT_TERMS_LINK: 'Términos y Condiciones',
  USD_ACCOUNT_CERT_TERMS_PRIVACY_LINK: 'Política de Privacidad',
  USD_ACCOUNT_CREATION_ERROR: 'Ocurrió un error al crear su cuenta. Por favor intente de nuevo.',
  USD_ACCOUNT_CREATION_TIMEOUT:
    'La creación de la cuenta está tardando más de lo esperado. Por favor cierra este diálogo y vuelve a verificar en unos momentos.',
  USD_ACCOUNT_DESCRIPTION:
    'Usa estos datos para recibir transferencias en USD. Los fondos se acreditarán al saldo de la cuenta.',
  USD_ACCOUNT_TERMS_DESCRIPTION:
    'Por favor, revisa y acepta las siguientes certificaciones para crear la cuenta USD.',
  USD_BALANCE: 'Saldo USD',
  USD_BALANCE_HEADLINE: 'Mantén y paga en USD',
  USD_BALANCE_HELPER:
    'Fondea desde rieles locales o stablecoins. Envía pagos USD bajo el nombre de Caliza.',
  USD_BALANCE_SUBTITLE: 'Mantén y transfiere USD',
  USD_BANNER_DESCRIPTION:
    'Mantén USD y envía pagos por defecto. Agrega cuentas USD para depósitos ACH/Wire/SWIFT, pagos nominados y conciliación.',
  USD_BANNER_TITLE: 'Nuevo: Los saldos USD ahora funcionan sin una cuenta USD.',
  USD_FOR_DOMESTIC_ACH_AND_WIRES_ONLY: 'USD (ACH y Wires)',
  USER: 'usuario',
  USERS: 'usuarios',
  USE_CUSTOMER_BALANCE: 'Usa el saldo del cliente',
  USE_KEY: 'Usar clave',
  USE_YOUR_CALIZA_BALANCE: 'Usa tu saldo de Caliza',
  US_DOLLAR: 'US Dollar',
  VALIDATION_ACTIVE_USER_CONFLICT: 'Este correo electrónico ya está vinculado a un usuario activo',

  VALIDATION_CNAPS_CODE_INVALID: 'El código CNAPS debe tener exactamente 12 dígitos',
  // New hardcoded strings that need translation
  VALIDATION_CVU_INVALID: 'CVU ou CBU debe tener exactamente 22 dígitos',
  VALIDATION_IFSC_CODE_INVALID:
    'El código IFSC debe tener 4 letras, un 0 y 6 caracteres alfanuméricos',
  VALIDATION_INVALID_SWIFT_CHARACTERS: 'El código SWIFT solo puede contener letras y números',
  VALIDATION_MSISDN_INVALID:
    'El número de teléfono debe estar en formato internacional, ej. +254712345678',
  VALIDATION_PASSWORD_MIN_12: 'La contraseña debe tener un mínimo de 12 caracteres',

  VALIDATION_PASSWORD_NUMBER: 'La contraseña debe tener un mínimo de 1 número',

  VALIDATION_PASSWORD_SPECIAL_CHARACTER:
    'La contraseña debe tener un mínimo de 1 carácter especial',

  VALIDATION_REQUIRED: '{0} is required',

  VALIDATION_ROUTING_CODE_INVALID: 'El código de ruta debe tener 8 o 9 dígitos',

  VALIDATION_SWIFT_BIC_COUNTRY_MISMATCH:
    'El país del código SWIFT/BIC no coincide con el país de destino seleccionado. Verifica el código SWIFT o cambia el país.',

  VALIDATION_TOO_LONG_16: '{0} debe tener menos de 16 caracteres',
  VALIDATION_TOO_LONG_20: '{0} debe tener menos de 20 caracteres',
  VALIDATION_TOO_LONG_70: '{0} debe tener menos de 70 caracteres',
  VALIDATION_USER_CONFLICT:
    'Ya se envió una invitación a este correo electrónico para unirse a tu equipo',
  VALUE: 'Valor',
  VARIABLE: 'Variable',
  VA_ACCOUNTS_DESCRIPTION:
    'Crea cuentas dedicadas con números de cuenta únicos para ACH, Wires, RTP y SWIFT.',
  VA_ACCOUNTS_HEADLINE: 'Recibe y envía USD a tu nombre',
  VA_BENEFIT_DEDICATED_DESC: 'Números de cuenta únicos asignados exclusivamente a este cliente',
  VA_BENEFIT_DEDICATED_TITLE: 'Cuentas dedicadas',
  VA_BENEFIT_MULTIPLE_DESC:
    'Crea múltiples cuentas para diferentes propósitos o unidades de negocio',
  VA_BENEFIT_MULTIPLE_TITLE: 'Múltiples cuentas',
  VA_BENEFIT_RAILS_DESC: 'Recibe depósitos por todas las principales vías de pago de EE.UU.',
  VA_BENEFIT_RAILS_TITLE: 'ACH, Wire, SWIFT',
  VA_DEPOSITS_FOOTER: 'Los depósitos en estas cuentas se reflejan en tu saldo USD arriba.',
  VA_SECTION_SUBTITLE: 'Crea múltiples cuentas dedicadas para recibir y enviar USD a tu nombre.',
  VERIFICATION_STATUS: 'Estado de verificación',
  VERIFY: 'Verificar',
  VERIFY_BUSINESS_ADDRESS: 'Dirección',
  VERIFY_BUSINESS_ADDRESS_LABEL: 'Dirección',
  VERIFY_BUSINESS_ADD_ANOTHER_OWNER: 'Agregar otro propietario',
  VERIFY_BUSINESS_ADD_SOCIAL_MEDIA: 'Agregar otro canal de redes sociales',
  VERIFY_BUSINESS_ANNUAL_INCOME: 'Ingreso anual',
  VERIFY_BUSINESS_BANK_STATEMENT: 'Estado de cuenta bancario',
  VERIFY_BUSINESS_BANNER: 'Verifica tu negocio para enviar tu primer pago',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_DESC:
    'A beneficial owner is any individual who directly or indirectly owns 25% or more of your company.',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_TITLE: 'Propietarios beneficiarios',
  VERIFY_BUSINESS_BENEFICIAL_OWNER_ADDRESS_QUESTION: "What is the beneficial owner's address?",
  VERIFY_BUSINESS_BENEFICIAL_OWNER_COUNTER: 'Propietario beneficiario #{0}',
  VERIFY_BUSINESS_BUSINESS_CONTACT_DESC:
    'The business representative is the primary point of contact who will manage the business relationship and ongoing operations with Caliza.',
  VERIFY_BUSINESS_BUSINESS_CONTACT_TITLE: 'Contacto de negocios',
  VERIFY_BUSINESS_CITY: 'Ciudad',
  VERIFY_BUSINESS_CNPJ: 'CNPJ',
  VERIFY_BUSINESS_CNPJ_FORMAT: 'El CNPJ debe seguir este formato: 12.345.678/9012-34',
  VERIFY_BUSINESS_CNPJ_QUESTION: '¿Cuál es el CNPJ?',
  VERIFY_BUSINESS_CNPJ_REGISTRATION: 'Registro CNPJ',
  VERIFY_BUSINESS_COMMERCIAL_NAME: 'Nombre comercial',
  VERIFY_BUSINESS_COMMERCIAL_NAME_QUESTION: "What is the company's commercial business name?",
  VERIFY_BUSINESS_COMPANY_DETAILS_TITLE: 'Detalles de la empresa',
  VERIFY_BUSINESS_COMPANY_PROFILE_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_COMPANY_PROFILE_TITLE: 'Perfil de la empresa',
  VERIFY_BUSINESS_CONTACT_INFORMATION: 'Información de contacto',
  VERIFY_BUSINESS_CONTACT_INFORMATION_QUESTION: '¿Cuál es su información de contacto?',
  VERIFY_BUSINESS_CONTACT_LABEL: 'Contacto',
  VERIFY_BUSINESS_CONTACT_QUESTION: '¿Quién es el punto de contacto para el negocio?',
  VERIFY_BUSINESS_COUNTRIES: 'Países',
  VERIFY_BUSINESS_CUSTOMER_COUNTRIES_QUESTION: '¿En qué países están ubicados tus clientes?',
  VERIFY_BUSINESS_CUSTOMER_DESCRIPTION: 'Una descripción de tu cliente',
  VERIFY_BUSINESS_CUSTOMER_INDUSTRIES_QUESTION:
    'Which industries do you have customers in? Select all that apply',
  VERIFY_BUSINESS_CUSTOMER_QUANTITY_QUESTION: '¿Cuántos clientes aproximados tienes?',
  VERIFY_BUSINESS_CUSTOMER_TYPE_QUESTION:
    'What type of customers do you have? Select all that apply',
  VERIFY_BUSINESS_DOCUMENTS: 'Documentos',
  // Additional tr() arguments that need symbols
  VERIFY_BUSINESS_DOCUMENTS_DESCRIPTION:
    'Please upload the company documents below. We support PDF, JPG, JPEG, PNG, and Word formats of a maximum size of [20] MB',
  VERIFY_BUSINESS_DOCUMENTS_TITLE: 'Documentos',
  VERIFY_BUSINESS_EMAIL: 'Correo electrónico',
  VERIFY_BUSINESS_EMAIL_QUESTION: '¿Cuál es su correo electrónico?',
  VERIFY_BUSINESS_ENTITY_TYPE: 'Tipo de entidad',
  VERIFY_BUSINESS_ENTITY_TYPE_QUESTION: '¿Cuál es el tipo de entidad?',
  VERIFY_BUSINESS_EXPECTED_RANGE: 'Rango $ esperado',
  VERIFY_BUSINESS_FINANCIAL_INSTITUTION_QUESTION: '¿Eres una institución de pago o financiera?',
  VERIFY_BUSINESS_FIRST_NAME: 'Nombre',
  VERIFY_BUSINESS_INCORPORATION_DOCUMENT: 'Documento de incorporación o estatutos de incorporación',
  VERIFY_BUSINESS_INDUSTRY_QUESTION: '¿En qué industria está tu negocio?',
  VERIFY_BUSINESS_LAST_NAME: 'Apellido',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME: 'Nombre de entidad legal',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_HELP:
    'Legal entity name must exactly match "NOME EMPRESARIAL" in your company\'s "CADASTRO NACIONAL DA PESSOA JURÍDICA" document.',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_QUESTION: '¿Cuál es el nombre de la entidad legal?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_DESC:
    'A legal representative is an individual with legal authority and powers to represent your company.',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_LABEL: 'Representante legal',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_QUESTION:
    'Who is the legal representative of this business?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_TITLE: 'Representante legal',
  VERIFY_BUSINESS_LICENSE_REQUIRED:
    'Are you required to have a license to operate in Brazil or another jurisdiction?',
  VERIFY_BUSINESS_MAIN_ADDRESS_QUESTION: "What is the company's main business address?",
  VERIFY_BUSINESS_MAIN_INDUSTRY: 'Industria principal',
  VERIFY_BUSINESS_NATIONALITY: 'Nacionalidad',
  VERIFY_BUSINESS_NUMBER_OF_CUSTOMERS: 'Número de clientes',
  VERIFY_BUSINESS_OCCUPATION: 'Ocupación',
  VERIFY_BUSINESS_ONLINE_PRESENCE_DESC:
    'Please share any other websites or online channels that could help us to better understand your business. These include social media accounts, e-commerce stores, and app store links.',
  VERIFY_BUSINESS_ONLINE_PRESENCE_TITLE: 'Presencia en línea',
  VERIFY_BUSINESS_OPERATIONS_TITLE: 'Operaciones del negocio',
  VERIFY_BUSINESS_OPERATION_COUNTRIES_QUESTION: '¿En qué países operas?',
  VERIFY_BUSINESS_OPERATION_STARTED: 'Operación iniciada',
  VERIFY_BUSINESS_OPERATION_START_QUESTION: '¿Cuándo comenzó operaciones la empresa?',
  VERIFY_BUSINESS_ORGANIZATION_TITLE: 'Organización',
  VERIFY_BUSINESS_OWNER: 'Propietario',
  VERIFY_BUSINESS_PERCENTAGE_OWNERSHIP: 'Porcentaje de propiedad',
  VERIFY_BUSINESS_PHONE: 'Teléfono',
  VERIFY_BUSINESS_PHONE_NUMBER: 'Número de teléfono',
  VERIFY_BUSINESS_PHONE_QUESTION: '¿Cuál es su número de teléfono?',
  VERIFY_BUSINESS_POSITION: 'Posición',
  VERIFY_BUSINESS_POSITION_QUESTION: '¿Cuál es su posición?',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY: 'Poder notarial',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY_HELP:
    'Please provide a standing general Power of Attorney or a limited Power of Attorney that assigns authority to open accounts and sign contracts on behalf of the business',
  VERIFY_BUSINESS_SERVICES_DESCRIPTION: 'Descripción de productos y servicios (Mínimo 8 palabras)',
  VERIFY_BUSINESS_SERVICES_QUESTION: '¿Qué productos o servicios ofrece tu negocio?',
  VERIFY_BUSINESS_SOCIAL_MEDIA_QUESTION: '¿Cuáles son tus canales de redes sociales? (Opcional)',
  VERIFY_BUSINESS_SOLE_PROPRIETOR_SKIP:
    'This section is not required since you are a sole proprietorship',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS: 'Fuente de fondos',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_TITLE: 'Fuente de fondos',
  VERIFY_BUSINESS_SOURCE_OF_WEALTH: 'Fuente de riqueza',
  VERIFY_BUSINESS_STATE: 'Estado',
  VERIFY_BUSINESS_SUITE_FLOOR_APT: 'Suite / Piso / Apto',
  VERIFY_BUSINESS_SUPPORTED_ID_DOCS:
    'Documentos de identificación admitidos (Pasaporte, Licencia de conducir o Registro General)',
  VERIFY_BUSINESS_TAX_ID: 'ID fiscal',
  VERIFY_BUSINESS_THIRD_PARTY_QUESTION:
    'Do you intend to use Caliza to move funds on behalf of customers or other third parties?',
  VERIFY_BUSINESS_TITLE: 'Información del negocio',
  VERIFY_BUSINESS_TYPICAL_CUSTOMER_QUESTION: 'Por favor, describe tu cliente típico',
  VERIFY_BUSINESS_UPLOAD_ID: 'Subir Pasaporte, Licencia de Conducir o Registro General',
  VERIFY_BUSINESS_URL: 'URL',
  VERIFY_BUSINESS_USD_VOLUME_QUESTION:
    'What is the expected monthly $USD volume you will move using Caliza?',
  VERIFY_BUSINESS_WEBSITE_LINK: 'Enlace del sitio web',
  VERIFY_BUSINESS_WEBSITE_QUESTION: '¿Cuál es el sitio web de tu negocio?',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_TITLE: 'Tus clientes',
  VERIFY_BUSINESS_ZIP: 'Código postal',
  VERIFY_YOUR_BUSINESS: 'Verifica tu negocio',
  VET: 'Valor Efectivo Total',
  VET_TOOLTIP:
    'VET (Valor Efetivo Total) representa la tasa integral implícita, considerando el spread, otras tarifas e impuestos aplicables',
  VIEWER: 'Visualizador',
  VIEWER_DESCRIPTION:
    'Acceso solo lectura a las cuentas de la empresa, ver y descargar informes de historial de transacciones e actividades',
  VIEW_ACTIVITY: 'Ver y descargar historial de transacciones y reportes de actividad',
  VIEW_AND_DOWNLOAD_TRANSACTIONS:
    'Ver y descargar historial de transacciones y reporte de actividad',
  VIEW_USD_ACCOUNT: 'Ver cuenta USD',
  VIRTUAL_ACCOUNTS_COUNT: 'Cuentas Virtuales ({0} cuentas)',
  VOLUME_PROCESSED: 'Volumen con margen',
  VOLUME_PROCESSED_TOOLTIP:
    'Solo incluye transacciones completadas en las que se aplicó un margen FX (es decir, transacciones que generaron ganancias).',
  WALLET: 'Cartera',
  WALLET_ADDRESS_COPIED: 'Dirección copiada exitosamente',
  WALLET_BALANCE_CURRENCY: 'Saldo de cartera ${0} {1}',
  WALLET_BALANCE_LEGACY: 'Saldo de cartera ${0} Dolares digitales',
  WALLET_INFORMATION: 'Wallet information',
  WALLET_INFORMATION_WITH_CURRENCY: 'Wallet information ({0})',
  WEBHOOK_SECRET: 'Secreto de webhook',
  WEBHOOK_SECRET_ROTATED: 'Secreto de webhook rotado',
  WEBHOOK_SECRET_ROTATE_ERROR: 'No se pudo rotar el secreto de webhook',
  WELCOME_BACK: 'Bienvenido de nuevo',
  WELCOME_TITLE: 'Bienvenido de nuevo, {0}',
  WE_ARE_DEPOSITING_YOUR_FUNDS: 'Estamos depositando tus fondos',
  WE_DONT_SUPPORT_YOUR_COUNTRY_YET: 'No damos soporte a tu país todavía',
  WE_RECEIVED_PAYMENT_INITIATED: 'Hemos recibido tu pago e iniciado tu transferencia',
  WE_RECEIVED_PAYMENT_INITIATED_DESCRIPTION:
    'Revisa tu historial para seguir el estado de la transferencia. Los detalles de la transacción pueden tardar unos minutos antes de aparecer.',
  WHERE_SENDING_FUNDS: '¿A dónde estás enviando fondos?',
  WHO_ARE_YOU_DEPOSITING_FOR: '¿Para quién está depositando?',
  WHO_ARE_YOU_SENDING_FUNDS_ON_BEHALF_OF: '¿De parte de quién estás enviando fondos?',
  WIRE: 'Wire',
  WITHDRAW: 'Retirar',
  WITHDRAWAL: 'Retiro',
  WITHDRAWAL_ACCOUNT: 'Cuenta de retiro',
  WITHDRAWAL_TO: 'Retiro a {0}',
  WITHDRAWAL_TRANSACTION_HASH: 'Hash de transacción de retiro',
  WITHDRAW_FUNDS: 'Retirar fondos',
  YEAR: 'Año',
  YES: 'Sí',
  YOU: 'Tú',
  YOURE_ALMOST_DONE: "You're almost done!",
  YOUR_ACCOUNT: 'Tu cuenta',
  YOUR_ACCOUNTS: 'Tus cuentas',
  YOUR_BALANCES: 'Tus saldos',
  YOUR_CALIZA_PASSWORD: 'Tu contraseña de Caliza',
  YOUR_EARNINGS: 'Tus ganancias',
  YOUR_FUNDS_HAVE_BEEN_ADDED: 'Tus fondos se han agregado a tu cuenta',
  YOUR_FUNDS_HAVE_BEEN_SENT: 'Tus fondos han sido enviados',
  YOUR_FX_MARKUP: 'Tu margen FX',
  YOUR_ORGANIZATION: 'Tu organización',
  YOU_CLAIM: 'Tú reclamas',
  YOU_DO_NOT_HAVE_ENOUGH_FUNDS: 'No tienes fondos suficientes para completar esta transacción',
  YOU_PULL_FROM_CUSTOMER: 'Retiras del cliente',
  YOU_RECEIVE: 'Tú recibes',
  YOU_SEND: 'Tú envías',
  YOU_STILL_BE_ABLE_TO_EXPLORE_PRODUCT_DESCRIPTION:
    'Podrás seguir explorando nuestros productos, pero no podrás realizar pagos. Te notificaremos cuando estemos activos en tu país.',
  ZERO_RESULTS_FOUND: '0 resultados encontrados',
  ZIP: 'Código postal',
};
export default strings;
